import React, { useState, useEffect } from 'react';
import {
  Clock, User, BookOpen, CheckCircle, AlertTriangle, FileText, Calendar,
  Timer, ChevronLeft, ChevronRight, Send, History, Users, GraduationCap,
  ArrowLeft, ArrowRight, Eye, RefreshCw, Search, Filter, X, Check,
  ChevronDown, ChevronUp, Euro, AlertCircle, Settings, Plus, Loader2, CreditCard, DollarSign, CalendarX, Info
} from 'lucide-react';

import { api } from '../services/api';
import { Toast } from '../components/ui/Toast';
import { LongToast, shouldUseLongToast } from '../components/ui/LongToast';
import { useFeatures } from '../contexts/FeaturesContext';
import JustifierAnomalieDialog from './pointage/JustifierAnomalieDialog';
import { envoyerLotEnComptabilite, lireDroitsJustification } from './pointage/apiJustification';
import ConfirmDialog from './ConfirmDialog';
import CaseACocher from './ui/CaseACocher';
import InfoBulle from './ui/InfoBulle';
import ChampSelect from './ui/ChampSelect';

// Ce qui a empêché de badger : le motif d'une saisie manuelle, revu au Centre
// de Support (mêmes clés que SaisieManuellePointageService.MOTIFS_SAISIE).
// Forme { valeur, libelle } de ChampSelect, la liste déroulante de la charte.
const MOTIFS_SAISIE_MANUELLE = [
  { valeur: 'oubli_badge', libelle: 'Oubli du badge' },
  { valeur: 'badge_perdu', libelle: 'Badge perdu ou abîmé' },
  { valeur: 'probleme_borne', libelle: 'Borne en panne' },
  { valeur: 'mission', libelle: 'Mission ou déplacement de service' },
  { valeur: 'autre', libelle: 'Autre (à préciser)' }
];

// Le filtre de statut de l'historique ; « tous » tient lieu de « aucun filtre ».
const FILTRES_STATUT_HISTORIQUE = [
  { valeur: 'tous', libelle: 'Tous les statuts' },
  { valeur: 'a_temps', libelle: "À l'heure" },
  { valeur: 'retard', libelle: 'En retard' },
  { valeur: 'absent', libelle: 'Absent' },
  { valeur: 'jour_non_travaille', libelle: 'Créneau non travaillé' },
  { valeur: 'trop_tot', libelle: 'Trop tôt' }
];

const CarnetPointageManuel = () => {
  // Le pointage se vend sans la paie.
  //
  // Il enregistre des presences ; la paie les transforme en heures payees. Sans
  // elle, le pointage reste ce qu'il est — un registre horodate avec son
  // historique — et tout ce qui pousse vers la remuneration disparait : la
  // colonne « Comptabilite », les deux boutons d'envoi, le compteur des
  // pointages envoyes.
  //
  // Rien n'est perdu en base. Le jour ou l'ecole prend la paie, les pointages
  // passes redeviennent envoyables tels quels.
  const { estActive } = useFeatures();
  const paieOuverte = estActive('module.paie');


  const formatDateForAPI = (date) => {
    return date.getFullYear() + '-' +
           String(date.getMonth() + 1).padStart(2, '0') + '-' +
           String(date.getDate()).padStart(2, '0');
  };

  // États principaux

 const [selectedDate, setSelectedDate] = useState(new Date());
  // La ligne dont on justifie l'anomalie ({ employe, pointage }), ou null.
  const [anomalieAJustifier, setAnomalieAJustifier] = useState(null);
  // Les lignes en cours de saisie dont on a ouvert le champ « note ».
  const [notesOuvertes, setNotesOuvertes] = useState(() => new Set());
  // Le champ note à focaliser, une seule fois, juste après le clic sur
  // « Ajouter une note » (un autoFocus déclaratif le reprenait à chaque
  // réouverture de la section).
  const [noteAFocaliser, setNoteAFocaliser] = useState(null);
  // La personne connectée peut-elle justifier ou corriger ? Lu une fois ; sans
  // le droit, l'écran le dit au lieu d'un bouton que le serveur refuserait.
  const [peutJustifier, setPeutJustifier] = useState(false);
  // La fenêtre ouverte sur le seul geste « Corriger l'heure » (journée en
  // cours, départ oublié, correction à reprendre).
  const [seulementCorriger, setSeulementCorriger] = useState(false);
  // « Tout envoyer en compta » : la confirmation, et l'envoi en cours.
  const [confirmationEnvoiLot, setConfirmationEnvoiLot] = useState(false);
  const [envoiLotEnCours, setEnvoiLotEnCours] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [viewMode, setViewMode] = useState('pointage'); // 'pointage' | 'historique'
  // États pour mode par lot avec catégories
  const [categorieActive, setCategorieActive] = useState(''); // Vide = tout fermé au départ
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [teacherSearchTerm, setTeacherSearchTerm] = useState('');
  const [showTeacherDropdown, setShowTeacherDropdown] = useState(false);
  // Ajoutez ces états avec vos autres états
const [timestampDebut, setTimestampDebut] = useState(null);
const [timestampFin, setTimestampFin] = useState(null);
const [pointagesExistants, setPointagesExistants] = useState([]);
const [pointageEnCours, setPointageEnCours] = useState(null);
const [heureFinValidee, setHeureFinValidee] = useState(false);



  // États dynamiques (ajoutez après vos états existants)
  const [enseignants, setEnseignants] = useState([]);
  const [activeYear, setActiveYear] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });


  // États pour mode individuel
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [arrivalTime, setArrivalTime] = useState('');
  const [departureTime, setDepartureTime] = useState('');
  const [observations, setObservations] = useState('');
  const [isPointageSaved, setIsPointageSaved] = useState(false);

  // États pour mode par lot
  const [batchMode, setBatchMode] = useState(false);
  //const [selectedTeachers, setSelectedTeachers] = useState([]);
  //const [selectedSections, setSelectedSections] = useState([]);
  //const [batchPointages, setBatchPointages] = useState([]);
  const [employesBatch, setEmployesBatch] = useState([]); //  NOUVEAU
const [pointagesBatch, setPointagesBatch] = useState([]); //  NOUVEAU - pour stocker les pointages
// La saisie manuelle passe par le Centre de Support (03/11/2026) : son motif,
// un commentaire, et la panne de borne, qui regroupe le lot en une demande.
// Les départs saisis à la main sur des lignes déjà pointées, par employé :
// { [employe_id]: { pointage_id, heure } }.
const [motifSaisie, setMotifSaisie] = useState('');
const [commentaireSaisie, setCommentaireSaisie] = useState('');
const [bornePanne, setBornePanne] = useState(false);
const [departsBatch, setDepartsBatch] = useState({});


  // États pour l'historique (ajoutez après vos autres états)
  const [pointagesData, setPointagesData] = useState([]);
  const [pointagesStats, setPointagesStats] = useState({ total: 0, a_temps: 0, retard: 0, absent: 0, envoyes_comptabilite: 0 });
  const [loadingHistorique, setLoadingHistorique] = useState(false);


  // etat pour l'horloge
  const [currentTime, setCurrentTime] = useState(new Date());




  // Fonctions pour votre système de Toast

// Modifiez showToast
const showToast = (message, type = 'success') => {
  // ✅ Protection contre les messages vides
  if (!message || message.trim() === '') {
    console.warn('⚠️ showToast appelé avec un message vide');
    return;
  }

  // 🔍 DEBUG : Afficher la stack trace pour voir QUI appelle showToast
  console.log('🍞 TOAST APPELÉ:', message, type);
  console.trace('📍 Appelé depuis:'); // ✅ Ceci va montrer d'où vient l'appel

  setToast({ show: true, message, type });
};


const hideToast = () => {
  setToast({ show: false, message: '', type: '' });
};;


// Un champ « note » ouvert ne survit ni au changement de date, ni à un lot
// vidé (Réinitialiser, ou enregistrement réussi) : sinon il se rouvrait seul,
// avec le focus, à la saisie suivante pour la même personne.
//
// Les brouillons du lot aussi : saisis pour une date, ils restaient en mémoire
// après un changement de jour, invisibles, et « Enregistrer » les écrivait sur
// la nouvelle date, par-dessus une ligne déjà badgée ou justifiée (revue du
// 14/10/2026). Un brouillon appartient à la date où il a été saisi.
useEffect(() => {
  setNotesOuvertes(new Set());
  setPointagesBatch([]);
  setDepartsBatch({});
}, [selectedDate]);
useEffect(() => {
  if (pointagesBatch.length === 0) setNotesOuvertes(new Set());
}, [pointagesBatch.length]);

useEffect(() => {
  let actif = true;
  lireDroitsJustification()
    .then((droits) => { if (actif) setPeutJustifier(Boolean(droits?.peut_justifier)); })
    .catch(() => { if (actif) setPeutJustifier(false); });
  return () => { actif = false; };
}, []);

// Auto-hide toast
useEffect(() => {
  if (toast.show) {
    const timer = setTimeout(() => {
      setToast({ show: false, message: '', type: '' }); // ✅ Réinitialisation complète
    }, 3000);
    return () => clearTimeout(timer);
  }
}, [toast.show]); // ✅ Dépendance uniquement sur toast.show



// Mettre à jour l'horloge chaque seconde
useEffect(() => {
  const timer = setInterval(() => {
    setCurrentTime(new Date());
  }, 1000); // ✅ Mise à jour toutes les 1 seconde

  return () => clearInterval(timer); // ✅ Nettoyage à la destruction du composant
}, []);



  // Fonctions utilitaires pour mode individuel
 const getAvailableSections = () => {
  if (!selectedTeacher) return [];
  const teacher = enseignants.find(t => t.id.toString() === selectedTeacher);
  return teacher ? teacher.sections : [];
};


      const getAvailableClasses = () => {
        if (!selectedSection) return [];
        const sections = getAvailableSections();
        const section = sections.find(s => s.id.toString() === selectedSection);

        return section ? section.classes : [];
      };



  // Fonction de chargement des données réelles
useEffect(() => {
  const loadData = async () => {
    try {

      //setToast({ show: false, message: '', type: '' });
      setIsLoading(true); //  Garde le loader global actif

      const yearResponse = await api.anneesScolaires.getActive();

      if (yearResponse.success && yearResponse.data) {
        setActiveYear(yearResponse.data);

       if (viewMode === 'pointage') {
        const enseignantsRes = await api.pointages.getEnseignantsAvecAffectations(
          yearResponse.data.id,
          formatDateForAPI(selectedDate)
        );

        if (enseignantsRes.success) {
          setEnseignants(enseignantsRes.data);
        }

        //  NOUVEAU : Charger aussi les employés pour le mode par lot
        if (batchMode) {
          const employesRes = await api.pointages.getEmployesPourPointage(
            yearResponse.data.id,
            formatDateForAPI(selectedDate)
          );

          if (employesRes.success) {
            setEmployesBatch(employesRes.data);
          }
        }

        await loadPointagesExistants();
      }


        if (viewMode === 'historique') {
          setLoadingHistorique(true);
          try {
            const dateForAPI = formatDateForAPI(selectedDate);
            const pointagesRes = await api.pointages.getByDate(dateForAPI);

            if (pointagesRes.success) {
              setPointagesData(pointagesRes.data);
              setPointagesStats(pointagesRes.stats);
            }
          } finally {
            setLoadingHistorique(false);
          }
        }
      }
    } catch (error) {
      console.error("Erreur:", error);
    } finally {
      setIsLoading(false);
    }
  };

  loadData();
}, [selectedDate, viewMode, batchMode]);



useEffect(() => {
  if (selectedClass && activeYear && viewMode === 'pointage') {
    setPointageEnCours(null);
    setArrivalTime('');
    setDepartureTime('');
    setTimestampDebut(null);
    setTimestampFin(null);
    setHeureFinValidee(false); //  Ajouter ici

    loadPointagesExistants();
  }
}, [selectedClass]);



  // Fonctions communes
  const getCurrentDate = () => {
    return selectedDate.toLocaleDateString('fr-FR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatDateForDisplay = (date) => {
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const calculateStatus = () => {
    if (!arrivalTime) return null;

    const selectedClassData = getAvailableClasses().find(c => c.affectation_id.toString() === selectedClass);
    if (!selectedClassData) return null;

    const scheduledStart = selectedClassData.horaire.split(' - ')[0];
    const [scheduledHour, scheduledMin] = scheduledStart.split('h').map(Number);
    const [arrivalHour, arrivalMin] = arrivalTime.split(':').map(Number);

    const scheduledTime = scheduledHour * 60 + (scheduledMin || 0);
    const actualArrival = arrivalHour * 60 + arrivalMin;
    const diffMinutes = actualArrival - scheduledTime;

    if (diffMinutes <= 15) {
      return {
        status: 'onTime',
        text: diffMinutes <= 0 ? 'À l\'heure' : `Léger retard (${diffMinutes} min)`,
        color: 'text-green-600',
        bg: 'bg-green-50',
        icon: CheckCircle
      };
    } else {
      return {
        status: 'late',
        text: `Retard de ${diffMinutes} min`,
        color: 'text-red-600',
        bg: 'bg-red-50',
        icon: AlertTriangle
      };
    }
  };

  const calculateBatchStatus = (pointage) => {
    if (!pointage.arrivalTime) return null;

    const scheduledStart = pointage.horaire.split(' - ')[0];
    const [scheduledHour, scheduledMin] = scheduledStart.split('h').map(Number);
    const [arrivalHour, arrivalMin] = pointage.arrivalTime.split(':').map(Number);

    const scheduledTime = scheduledHour * 60 + (scheduledMin || 0);
    const actualArrival = arrivalHour * 60 + arrivalMin;
    const diffMinutes = actualArrival - scheduledTime;

    if (diffMinutes <= 15) {
      return {
        status: 'onTime',
        text: diffMinutes <= 0 ? 'À l\'heure' : `Léger retard (${diffMinutes} min)`,
        color: 'text-green-600',
        bg: 'bg-green-50'
      };
    } else {
      return {
        status: 'late',
        text: `Retard de ${diffMinutes} min`,
        color: 'text-red-600',
        bg: 'bg-red-50'
      };
    }
  };

  const resetForm = () => {
    setSelectedTeacher('');
    setSelectedSection('');
    setSelectedClass('');
    setArrivalTime('');
    setDepartureTime('');
    setObservations('');
    setIsPointageSaved(false);
    setHeureFinValidee(false);
  };

  /*const resetBatchForm = () => {
    setSelectedTeachers([]);
    setSelectedSections([]);
    setBatchPointages([]);
  }; */


  const goToPreviousDay = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() - 1);
    setSelectedDate(newDate);
  };

  const goToNextDay = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() + 1);
    setSelectedDate(newDate);
  };

  const goToToday = () => {
    console.log("=== BOUTON AUJOURD'HUI ===");
  const today = new Date();
  console.log("Date d'aujourd'hui:", today.toISOString().split('T')[0]);
    setSelectedDate(new Date());
  };


 const handleSavePointage = async () => {
  if (!selectedTeacher || !selectedClass) {
    setToast({ show: true, message: 'Veuillez sélectionner un enseignant et une classe', type: 'error' });
    return;
  }

  // Vérifier qu'au moins l'heure de début est pointée
  if (!arrivalTime) {
    setToast({ show: true, message: 'Veuillez pointer au moins l\'heure de début', type: 'error' });
    return;
  }

  setLoading(true);
  try {
    const selectedClassData = getAvailableClasses().find(c => c.affectation_id.toString() === selectedClass);

    if (!selectedClassData) {
      setToast({ show: true, message: 'Classe sélectionnée introuvable', type: 'error' });
      return;
    }

    const horaireParts = selectedClassData.horaire.split(' - ');
    const today = formatDateForAPI(selectedDate);

    // Utiliser les timestamps capturés au moment du clic (ou maintenant si pas encore capturés)
    let heure_pointage_debut_reelle = timestampDebut;
    let heure_pointage_fin_reelle = timestampFin;

    // Fallback : si pas de timestamp capturé, utiliser l'heure actuelle
    if (arrivalTime && !heure_pointage_debut_reelle) {
      heure_pointage_debut_reelle = new Date().toISOString();
    }

    if (departureTime && !heure_pointage_fin_reelle) {
      heure_pointage_fin_reelle = new Date().toISOString();
    }

    const pointageData = {
      enseignant_id: parseInt(selectedTeacher),
      classe_id: parseInt(selectedClassData.id),
      matiere_id: selectedClassData.matiere_id,
      annee_scolaire_id: activeYear.id,
      affectation_id: parseInt(selectedClass),
      date_pointage: today,

      // Heures prévues (format HH:MM)
      heure_debut_prevue: horaireParts[0].replace('h', ':'),
      heure_fin_prevue: horaireParts[1].replace('h', ':'),

      // Timestamps exacts du pointage (ISO format avec timezone)
      heure_pointage_debut_reelle,
      heure_pointage_fin_reelle,
      timezone_pointage: Intl.DateTimeFormat().resolvedOptions().timeZone,
      observations: observations,

      // Heures legacy pour compatibilité (format HH:MM)
      heure_arrivee: arrivalTime,
      heure_depart: departureTime,

      observations: observations
    };

    // Debug pour vérifier les données envoyées
    console.log('=== DEBUG POINTAGE ===');
    console.log('Données envoyées:', pointageData);
    console.log('Timezone détectée:', Intl.DateTimeFormat().resolvedOptions().timeZone);
    console.log('Heure locale actuelle:', new Date().toLocaleString('fr-FR'));
    console.log('Timestamp début capturé:', timestampDebut);
    console.log('Timestamp fin capturé:', timestampFin);
    console.log('=====================');

    const response = await api.pointages.enregistrer(pointageData);

    if (response.success) {
      setIsPointageSaved(true);

      // Message de succès avec détails des statuts calculés
      let successMessage = 'Pointage enregistré avec succès !';

      if (response.data.statut_debut) {
        successMessage += ` Début: ${response.data.statut_debut}`;
      }

      if (response.data.statut_fin) {
        successMessage += ` - Fin: ${response.data.statut_fin}`;
      }

      if (response.data.duree_effective_minutes !== null) {
        const heures = Math.floor(response.data.duree_effective_minutes / 60);
        const minutes = response.data.duree_effective_minutes % 60;
        successMessage += ` (Durée: ${heures}h${minutes.toString().padStart(2, '0')})`;
      }

      setToast({
        show: true,
        message: successMessage,
        type: 'success'
      });


      await loadPointagesExistants();

      // Debug des résultats calculés par le backend
      console.log('=== RÉSULTATS BACKEND ===');
      console.log('Statut début:', response.data.statut_debut);
      console.log('Statut fin:', response.data.statut_fin);
      console.log('Statut global:', response.data.statut_global);
      console.log('Durée effective (min):', response.data.duree_effective_minutes);
      console.log('========================');

    } else {
      setToast({
        show: true,
        message: response.message || 'Erreur lors de l\'enregistrement',
        type: 'error'
      });
    }
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement du pointage:', error);
    setToast({
      show: true,
      message: 'Erreur lors de l\'enregistrement du pointage',
      type: 'error'
    });
  } finally {
    setLoading(false);
  }
};


// Enregistrer uniquement le début du pointage
const handleEnregistrerDebut = async () => {
  if (!selectedTeacher || !selectedClass || !arrivalTime) {
    setToast({ show: true, message: 'Veuillez pointer l\'heure de début', type: 'error' });
    return;
  }

  setLoading(true);
  try {
    const selectedClassData = getAvailableClasses().find(c => c.affectation_id.toString() === selectedClass);
    const horaireParts = selectedClassData.horaire.split(' - ');
    const today = formatDateForAPI(selectedDate);

    const pointageData = {
      enseignant_id: parseInt(selectedTeacher),
      classe_id: parseInt(selectedClassData.id),
      matiere_id: selectedClassData.matiere_id,
      annee_scolaire_id: activeYear.id,
      affectation_id: parseInt(selectedClass),
      date_pointage: today,
      heure_debut_prevue: horaireParts[0].replace('h', ':'),
      heure_fin_prevue: horaireParts[1].replace('h', ':'),
      heure_pointage_debut_reelle: timestampDebut,
      timezone_pointage: Intl.DateTimeFormat().resolvedOptions().timeZone,
      heure_arrivee: arrivalTime,
      observations: observations
    };

    const response = await api.pointages.enregistrer(pointageData);

    if (response.success) {
      setPointageEnCours({
        id: response.data.id,
        enseignant_id: parseInt(selectedTeacher),
        affectation_id: parseInt(selectedClass),
        classe: selectedClassData,
        timestampDebut: timestampDebut,
        arrivalTime: arrivalTime
      });

      /*
      setToast({
        show: true,
        message: 'Début de cours enregistré ! En attente du pointage de fin.',
        type: 'success'
      });

      */
    }
  } catch (error) {
    console.error('Erreur:', error);
    setToast({ show: true, message: 'Erreur lors de l\'enregistrement', type: 'error' });
  } finally {
    setLoading(false);
  }
};

// Compléter le pointage avec l'heure de fin
const handleCompleterPointage = async () => {
  if (!pointageEnCours || !departureTime) {
    /*setToast({ show: true, message: 'Veuillez pointer l\'heure de fin', type: 'error' });*/
    return;
  }

  setLoading(true);
  try {
    const response = await api.pointages.completer(pointageEnCours.id, {
      heure_pointage_fin_reelle: timestampFin,
      heure_depart: departureTime,
      timezone_pointage: Intl.DateTimeFormat().resolvedOptions().timeZone,
      observations: observations
    });

    if (response.success) {
      setToast({
        show: true,
        message: 'Pointage compléte avec succès !',
        type: 'success'
      });

      // Réinitialiser
      setPointageEnCours(null);
      resetForm();
      await loadPointagesExistants();
    }
  } catch (error) {
    console.error('Erreur:', error);
    setToast({ show: true, message: 'Erreur lors de la complétion', type: 'error' });
  } finally {
    setLoading(false);
  }
};




const handleMarquerAbsent = () => {
  // Marquer comme absent sans enregistrer
  setArrivalTime('ABSENT');
  setDepartureTime('ABSENT');
  setTimestampDebut(null);
  setTimestampFin(null);

  setToast({
    show: true,
    message: 'Absence marquée. Cliquez sur "Enregistrer le pointage" pour valider.',
    type: 'info'
  });
};


// Enregistrer l'absence en base de données
const handleAbsent = async () => {
  if (!selectedTeacher || !selectedClass) {
    /*setToast({ show: true, message: 'Veuillez sélectionner un enseignant et une classe', type: 'error' });*/
    return;
  }

  setLoading(true);
  try {
    const selectedClassData = getAvailableClasses().find(c => c.affectation_id.toString() === selectedClass);

    if (!selectedClassData) {
      setToast({ show: true, message: 'Classe sélectionnée introuvable', type: 'error' });
      return;
    }

    const horaireParts = selectedClassData.horaire.split(' - ');
    const today = formatDateForAPI(selectedDate);

    const pointageData = {
      enseignant_id: parseInt(selectedTeacher),
      classe_id: parseInt(selectedClassData.id),
      matiere_id: selectedClassData.matiere_id || null,
      annee_scolaire_id: activeYear.id,
      affectation_id: parseInt(selectedClass),
      date_pointage: today,

      heure_debut_prevue: horaireParts[0].replace('h', ':'),
      heure_fin_prevue: horaireParts[1].replace('h', ':'),
      statut: 'absent',

      // Absence = tout à null
      heure_arrivee: null,
      heure_depart: null,
      heure_pointage_debut_reelle: null,
      heure_pointage_fin_reelle: null,
      timezone_pointage: Intl.DateTimeFormat().resolvedOptions().timeZone,

      observations: observations || 'Absence'
    };

    const response = await api.pointages.enregistrer(pointageData);

    if (response.success) {
      setToast({
        show: true,
        message: 'Absence enregistrée avec succès',
        type: 'success'
      });

      resetForm();
      await loadPointagesExistants();
    } else {
      setToast({
        show: true,
        message: response.message || 'Erreur lors de l\'enregistrement',
        type: 'error'
      });
    }
  } catch (error) {
    console.error('Erreur:', error);
    setToast({ show: true, message: 'Erreur lors de l\'enregistrement de l\'absence', type: 'error' });
  } finally {
    setLoading(false);
  }
};



const handleMarquerCreneauNonTravaille = () => {
  setArrivalTime('NON_TRAVAILLE');
  setDepartureTime('NON_TRAVAILLE');
  setTimestampDebut(null);
  setTimestampFin(null);

  setToast({
    show: true,
    message: 'Créneau non travaillé marqué. Cliquez sur "Enregistrer le créneau non travaillé" pour valider.',
    type: 'info'
  });
};

const handleCreneauNonTravaille = async () => {
  if (!selectedTeacher || !selectedClass) {
    return;
  }

  setLoading(true);
  try {
    const selectedClassData = getAvailableClasses().find(c => c.affectation_id.toString() === selectedClass);

    if (!selectedClassData) {
      setToast({ show: true, message: 'Classe sélectionnée introuvable', type: 'error' });
      return;
    }

    const horaireParts = selectedClassData.horaire.split(' - ');
    const today = formatDateForAPI(selectedDate);

    const pointageData = {
      enseignant_id: parseInt(selectedTeacher),
      classe_id: parseInt(selectedClassData.id),
      matiere_id: selectedClassData.matiere_id || null,
      annee_scolaire_id: activeYear.id,
      affectation_id: parseInt(selectedClass),
      date_pointage: today,
      heure_debut_prevue: horaireParts[0].replace('h', ':'),
      heure_fin_prevue: horaireParts[1].replace('h', ':'),
      statut: 'jour_non_travaille',
      heure_arrivee: null,
      heure_depart: null,
      heure_pointage_debut_reelle: null,
      heure_pointage_fin_reelle: null,
      timezone_pointage: Intl.DateTimeFormat().resolvedOptions().timeZone,
      observations: observations || 'Créneau non travaillé'
    };

    const response = await api.pointages.enregistrer(pointageData);

    if (response.success) {
      setToast({
        show: true,
        message: 'Créneau non travaillé enregistré avec succès',
        type: 'success'
      });

      resetForm();
      await loadPointagesExistants();
    } else {
      setToast({
        show: true,
        message: response.message || "Erreur lors de l'enregistrement",
        type: 'error'
      });
    }
  } catch (error) {
    console.error('Erreur:', error);
    setToast({ show: true, message: "Erreur lors de l'enregistrement du créneau non travaillé", type: 'error' });
  } finally {
    setLoading(false);
  }
};



const handleSaveBatchPointages = async () => {
  const departs = Object.entries(departsBatch).map(([employeId, depart]) => ({
    employe_id: Number(employeId),
    pointage_id: depart.pointage_id,
    heure_depart: depart.heure
  }));
  if (pointagesBatch.length === 0 && departs.length === 0) {
    showToast('Veuillez pointer au moins un employé', 'error');
    return;
  }
  // « Présent », « jour non travaillé » et les départs saisis à la main passent
  // par le Centre de Support : le motif est exigé avant l'envoi (03/11/2026).
  const aValider = departs.length > 0 || pointagesBatch.some((p) => p.statut !== 'absent');
  if (departs.some((d) => !d.heure_depart)) {
    showToast("Indiquez l'heure de chaque départ saisi", 'error');
    return;
  }
  if (aValider && !motifSaisie) {
    showToast('Choisissez le motif de la saisie manuelle : elle sera validée au Centre de Support', 'error');
    return;
  }
  if (aValider && motifSaisie === 'autre' && !commentaireSaisie.trim()) {
    showToast('Précisez le motif de la saisie manuelle', 'error');
    return;
  }

  setLoading(true);
  try {
    const pointagesData = pointagesBatch.map(pointage => ({
      employe_id: pointage.employe_id,
      annee_scolaire_id: activeYear.id,
      date_pointage: formatDateForAPI(selectedDate),
      heure_pointage_reelle: pointage.timestamp,
      timezone_pointage: Intl.DateTimeFormat().resolvedOptions().timeZone,
      heure_arrivee: pointage.heure,
      statut: pointage.statut,
      observations: pointage.observations || ''
    }));


    // ✅ DEBUG : Voir ce qui est envoyé
    console.log('🔍 DONNÉES ENVOYÉES AU BACKEND:', JSON.stringify(pointagesData, null, 2));

    const response = await api.pointages.enregistrerLotEmployes({
      pointages: pointagesData,
      departs,
      ...(aValider ? { motif: motifSaisie, commentaire: commentaireSaisie.trim(), panne: bornePanne } : {})
    });

    // ⚠️ LE TOAST DIT CE QUE LE SERVEUR A VRAIMENT ÉCRIT. Il annonçait le
    // nombre de lignes ENVOYÉES, et le serveur répondait toujours succès :
    // aucun pointage par lot n'était enregistré depuis le 31/07/2026, sans que
    // rien ne le dise (03/11/2026). Les lignes écrites quittent la saisie ; les
    // lignes refusées y restent, nommées dans le message, pour être reprises.
    const enregistrees = new Set((response.data?.results || []).map((ligne) => Number(ligne.employe_id)));
    const refusees = response.data?.errors || [];

    if (response.success) {
      showToast(response.message || `${enregistrees.size} pointage(s) enregistré(s)`, 'success');
    } else {
      const nomDe = (id) => {
        const employe = employesBatch.find((e) => Number(e.id) === Number(id));
        return employe ? `${employe.prenom || ''} ${employe.nom || ''}`.trim() : `Employé #${id}`;
      };
      const detail = refusees.map((ligne) => `${nomDe(ligne.employe_id)} : ${ligne.error}`).join(' ; ');
      showToast(
        [response.message || response.error || "Erreur lors de l'enregistrement", detail].filter(Boolean).join('. '),
        'error'
      );
    }

    if (response.success) {
      setMotifSaisie('');
      setCommentaireSaisie('');
      setBornePanne(false);
    }

    if (enregistrees.size > 0) {
      setPointagesBatch((prev) => prev.filter((p) => !enregistrees.has(Number(p.employe_id))));
      setDepartsBatch((prev) => Object.fromEntries(
        Object.entries(prev).filter(([employeId]) => !enregistrees.has(Number(employeId)))
      ));

      // Recharger les employés
      const employesRes = await api.pointages.getEmployesPourPointage(
        activeYear.id,
        formatDateForAPI(selectedDate)
      );
      if (employesRes.success) {
        setEmployesBatch(employesRes.data);
      }
    }
  } catch (error) {
    console.error('Erreur:', error);
    showToast(error.message || 'Erreur lors de l\'enregistrement du lot', 'error');
  } finally {
    setLoading(false);
  }
};



const handleSendToAccounting = async (pointageId = null) => {
  try {
    setLoading(true);

    if (pointageId) {
      // Envoi individuel
      const response = await api.pointages.envoyerComptabilite(pointageId);

      if (response.success) {
        setToast({
          show: true,
          message: `Pointage envoyé à la comptabilité avec succès !`,
          type: 'success'
        });

        // Recharger les données de l'historique
        const dateForAPI = formatDateForAPI(selectedDate);
        const pointagesRes = await api.pointages.getByDate(dateForAPI);
        if (pointagesRes.success) {
          setPointagesData(pointagesRes.data);
          setPointagesStats(pointagesRes.stats);
        }
      } else {
        setToast({
          show: true,
          message: response.message || 'Erreur lors de l\'envoi',
          type: 'error'
        });
      }
    } else {
      // Envoi de tous les pointages de la journée
      const dateForAPI = formatDateForAPI(selectedDate);

      // CORRECTION ICI : Filtrer uniquement les pointages en attente (pas envoyés, pas en paiement, pas payés)
      const pointagesEnAttente = pointagesData.filter(p =>
        !['envoye', 'en_paiement', 'paye'].includes(p.statut_comptabilite)
      );

      if (pointagesEnAttente.length === 0) {
        setToast({
          show: true,
          message: 'Tous les pointages ont déjà été envoyés ou sont en cours de traitement',
          type: 'info'
        });
        return;
      }

      // Demander confirmation
      if (!window.confirm(`Voulez-vous envoyer ${pointagesEnAttente.length} pointage(s) en attente à la comptabilité ?`)) {
        setLoading(false);
        return;
      }

      const response = await api.pointages.envoyerTousComptabilite(dateForAPI);

      if (response.success) {
        setToast({
          show: true,
          message: `${pointagesEnAttente.length} pointage(s) envoyé(s) à  la comptabilité !`,
          type: 'success'
        });

        // Recharger les données
        const pointagesRes = await api.pointages.getByDate(dateForAPI);
        if (pointagesRes.success) {
          setPointagesData(pointagesRes.data);
          setPointagesStats(pointagesRes.stats);
        }
      } else {
        setToast({
          show: true,
          message: response.message || 'Erreur lors de l\'envoi groupé',
          type: 'error'
        });
      }
    }
  } catch (error) {
    console.error('Erreur envoi comptabilité:', error);
    setToast({
      show: true,
      message: 'Erreur lors de l\'envoi à la comptabilité',
      type: 'error'
    });
  } finally {
    setLoading(false);
  }
};


// Après une justification ou une correction : la ligne repart du serveur, qui
// a recalculé statut RH, retard et durée.
const handleAnomalieJustifiee = async (geste) => {
  setAnomalieAJustifier(null);
  // Une correction d'heures se valide au Centre de Support (03/11/2026) : la
  // ligne attend sa décision, elle n'est pas encore corrigée.
  showToast(geste === 'corriger' ? 'Correction envoyée au Centre de Support pour validation' : 'Anomalie justifiée', 'success');
  try {
    const employesRes = await api.pointages.getEmployesPourPointage(activeYear.id, formatDateForAPI(selectedDate));
    if (employesRes.success) setEmployesBatch(employesRes.data);
  } catch (error) {
    console.error('Erreur rechargement apres justification:', error);
  }
};

// « Tout envoyer en compta » : les lignes prêtes de la date affichée partent en
// une fois ; le serveur rend celles qu'il a écartées (déjà envoyées, à
// justifier). La liste est rechargée dans tous les cas.
const handleEnvoyerLotCompta = async () => {
  setConfirmationEnvoiLot(false);
  setEnvoiLotEnCours(true);
  try {
    const resultat = await envoyerLotEnComptabilite({
      ids: etatEnvoiLot.prets.map(p => p.id),
      datePointage: formatDateForAPI(selectedDate),
      anneeScolaireId: activeYear.id
    });
    const ecartees = resultat.ecartees?.length || 0;
    showToast(
      `${resultat.envoyes} pointage(s) envoyé(s) à la comptabilité` + (ecartees ? ` - ${ecartees} écarté(s) par le serveur` : ''),
      ecartees ? 'info' : 'success'
    );
  } catch (error) {
    showToast(error.message || "Erreur lors de l'envoi à la comptabilité", 'error');
  } finally {
    try {
      const employesRes = await api.pointages.getEmployesPourPointage(activeYear.id, formatDateForAPI(selectedDate));
      if (employesRes.success) setEmployesBatch(employesRes.data);
    } catch (error) {
      console.error('Erreur rechargement apres envoi groupe:', error);
    }
    setEnvoiLotEnCours(false);
  }
};

const handleEnvoyerEmployeCompta = async (pointageId) => {
  try {
    setLoading(true);

    const response = await api.pointages.envoyerEmployeComptabilite(pointageId);

    if (response.success) {
      showToast('Pointage envoyé à la comptabilité', 'success');

      // Recharger
      const employesRes = await api.pointages.getEmployesPourPointage(
        activeYear.id,
        formatDateForAPI(selectedDate)
      );
      if (employesRes.success) {
        setEmployesBatch(employesRes.data);
      }
    } else {
      showToast(response.message || 'Erreur lors de l\'envoi', 'error');
    }
  } catch (error) {
    console.error('Erreur:', error);
    showToast('Erreur lors de l\'envoi à la comptabilité', 'error');
  } finally {
    setLoading(false);
  }
};



 const filteredPointages = pointagesData.filter(pointage => {
  const matchesSearch = !searchTerm ||
    `${pointage.enseignant_nom} ${pointage.enseignant_prenom}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
    pointage.classe_nom.toLowerCase().includes(searchTerm.toLowerCase());

  const matchesStatus = !filterStatus || pointage.statut_debut === filterStatus;

  return matchesSearch && matchesStatus;
});


  const formatDurationFromMinutes = (minutes) => {
    if (minutes === null || minutes === undefined || Number.isNaN(Number(minutes))) return '-';
    const total = Math.max(0, Number(minutes));
    const heures = Math.floor(total / 60);
    const reste = total % 60;
    return heures + 'h' + String(reste).padStart(2, '0');
  };

  const formatHourValue = (value) => {
    if (!value) return '-';
    if (typeof value === 'string') {
      if (/^\d{2}:\d{2}/.test(value)) return value.slice(0, 5);
      const parsed = new Date(value);
      if (!Number.isNaN(parsed.getTime())) return parsed.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
      return value;
    }
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? '-' : parsed.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  };

  const getPresenceMeta = (statut) => {
    // La borne écrit le statut du calcul RH (`retard`, `trop_tot`,
    // `heures_sup`) : ce sont des présences. Jusqu'au 14/10/2026 ils tombaient
    // dans `default` et une personne arrivée en retard s'affichait « Absent ».
    switch (statut) {
      case 'present':
      case 'a_temps':
      case 'retard':
      case 'trop_tot':
      case 'heures_sup':
        return { label: 'Présent', className: 'bg-green-100 text-green-800', Icon: CheckCircle };
      case 'jour_non_travaille':
        return { label: 'Jour non travaillé', className: 'bg-gray-100 text-gray-800', Icon: CalendarX };
      case 'absent':
      default:
        return { label: 'Absent', className: 'bg-red-100 text-red-800', Icon: X };
    }
  };

  const getRhMeta = (pointage) => {
    if (!pointage) return null;
    // Saisie à la main en attente du Centre de Support (03/11/2026).
    if (pointage.statut_rh === 'en_validation') return { label: 'En validation', className: 'bg-amber-100 text-amber-800' };
    if (pointage.statut === 'jour_non_travaille') return { label: 'Non travaillé', className: 'bg-gray-100 text-gray-800' };
    if (pointage.statut === 'absent') return { label: 'Absence', className: 'bg-red-100 text-red-800' };
    if (Number(pointage.anomalie_pointage || 0) === 1) {
      if (['justifie', 'corrige'].includes(pointage.statut_rh)) {
        return { label: pointage.statut_rh === 'corrige' ? 'Corrigé RH' : 'Justifié RH', className: 'bg-blue-100 text-blue-800' };
      }
      return { label: 'À justifier', className: 'bg-orange-100 text-orange-800' };
    }
    return { label: 'Valide RH', className: 'bg-green-100 text-green-800' };
  };

  const getAnomalieLabels = (pointage) => {
    if (!pointage?.anomalies_pointage) return [];
    const labels = {
      retard: 'Retard' + (Number(pointage.minutes_retard || 0) > 0 ? ' : ' + pointage.minutes_retard + ' min' : ''),
      retard_debut: 'Retard' + (Number(pointage.minutes_retard || 0) > 0 ? ' : ' + pointage.minutes_retard + ' min' : ''),
      debut_trop_tot: 'Début trop tôt',
      absence: 'Absence À justifier',
      heures_supplementaires: 'Heures supplémentaires' + (Number(pointage.minutes_depassement || 0) > 0 ? ' : ' + pointage.minutes_depassement + ' min' : ''),
      depart_anticipe: 'Départ anticipé' + (Number(pointage.minutes_depart_anticipe || 0) > 0 ? ' : ' + pointage.minutes_depart_anticipe + ' min' : ''),
      depassement: 'Dépassement' + (Number(pointage.minutes_depassement || 0) > 0 ? ' : ' + pointage.minutes_depassement + ' min' : ''),
      fin_trop_tot: 'Fin trop tôt' + (Number(pointage.minutes_depart_anticipe || 0) > 0 ? ' : ' + pointage.minutes_depart_anticipe + ' min' : ''),
      fin_trop_tard: 'Fin tardive' + (Number(pointage.minutes_depassement || 0) > 0 ? ' : ' + pointage.minutes_depassement + ' min' : ''),
      pause_anticipee: 'Pause prise en avance',
      retour_tardif: 'Retour de pause tardif',
      pause_non_badgee: 'Pause non badgée',
      retour_non_badge: 'Retour de pause non badgé'
    };
    return String(pointage.anomalies_pointage).split(',').map(item => item.trim()).filter(Boolean).map(item => labels[item] || item.replace(/_/g, ' '));
  };

  // Une ligne en validation n'est pas « à justifier » : sa validation EST le
  // contrôle, et le serveur refuse de la justifier avant (03/11/2026).
  const requiresRhJustification = (pointage) => Number(pointage?.anomalie_pointage || 0) === 1
    && !['justifie', 'corrige', 'en_validation'].includes(pointage?.statut_rh);
  const enValidation = (pointage) => pointage?.statut_rh === 'en_validation';

  const renderComptabiliteEmploye = (pointage) => {
    if (!paieOuverte) return null;
    if (!pointage) return <span className="text-xs text-gray-400">-</span>;
    if (pointage.statut_comptabilite === 'en_attente') {
      // Une seule action par ligne : tant que l'anomalie n'est pas justifiée,
      // le bouton « Justifier » est dans la colonne Durée / RH, et celle-ci dit
      // seulement pourquoi l'envoi attend (plus de bouton grisé sans issue).
      if (enValidation(pointage)) {
        return <span className="text-xs text-gray-500">En validation au Centre de Support</span>;
      }
      if (requiresRhJustification(pointage)) {
        return <span className="text-xs text-gray-500">En attente de justification</span>;
      }
      // Mêmes retenues que « Tout envoyer en compta » : une ligne encore à
      // l'heure de Paris, ou une journée pas encore terminée, attend.
      if (pointage.fuseau_a_recalculer) {
        return <span className="text-xs text-gray-500">En attente du rattrapage (heure de Paris)</span>;
      }
      if (pointage.journee_ouverte) {
        return <span className="text-xs text-gray-500">Journée en cours</span>;
      }
      return (
        <button onClick={() => handleEnvoyerEmployeCompta(pointage.id)} disabled={loading} title="Envoyer à la comptabilité" className="h-8 w-[150px] text-xs px-3 bg-[#246990] text-white rounded-lg hover:bg-[#1f5a7a] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors inline-flex items-center justify-center gap-1.5">
          <Send className="w-3 h-3" /> Envoyer à la compta
        </button>
      );
    }
    return (
      <div className="space-y-1">
        <span className="px-3 py-1 bg-orange-100 text-orange-800 rounded text-sm font-medium inline-flex items-center gap-1"><Check className="w-3 h-3" /> Envoyé</span>
        {pointage.envoye_par_nom && pointage.statut_comptabilite === 'envoye' && (
          <div className="text-xs text-gray-500"><span className="font-medium">Envoyé par :</span> {pointage.envoye_par_nom}{pointage.heure_envoi && <span> à {formatHourValue(pointage.heure_envoi)}</span>}</div>
        )}
      </div>
    );
  };

  // Deux heures dans deux cases de même largeur, en chiffres tabulaires : les
  // plages s'alignent en colonne d'une ligne à l'autre.
  const plageHoraire = (debut, fin, finVide = null) => (
    <span className="inline-flex items-baseline font-medium text-gray-800 tabular-nums">
      <span className="w-[38px]">{debut && debut !== '-' ? debut : <span className="text-gray-300">--:--</span>}</span>
      <span className="w-[16px] text-center text-gray-400">-</span>
      <span className="min-w-[38px]">
        {fin && fin !== '-' ? fin : (finVide ? <span className="text-gray-400 font-normal">{finVide}</span> : <span className="text-gray-300">--:--</span>)}
      </span>
    </span>
  );

  // Un départ se saisit à la main sur une ligne pointée, encore en attente,
  // qui a une arrivée et pas de départ : la borne n'a pas pu le prendre. Il
  // part avec le lot, et se valide au Centre de Support (03/11/2026). L'heure
  // est celle de l'école, tapée par la personne qui saisit : pas de valeur
  // proposée, l'horloge de ce poste peut ne pas être à l'heure de l'école.
  const peutSaisirDepart = (pointage) => pointage?.statut_comptabilite === 'en_attente'
    && Boolean(pointage.heure_arrivee || pointage.heure) && !pointage.heure_depart
    && !['absent', 'jour_non_travaille'].includes(pointage.statut) && !pointage.fuseau_a_recalculer;
  const ajouterDepart = (employeId, pointageId) => setDepartsBatch((prev) => ({ ...prev, [employeId]: { pointage_id: pointageId, heure: '' } }));
  const modifierDepart = (employeId, heure) => setDepartsBatch((prev) => ({ ...prev, [employeId]: { ...prev[employeId], heure } }));
  const retirerDepart = (employeId) => setDepartsBatch((prev) => {
    const suivant = { ...prev };
    delete suivant[employeId];
    return suivant;
  });

  const renderPointageBatchDetails = (employe, draftPointage) => {
    const saved = Boolean(employe.deja_pointe && employe.pointage);
    const pointage = saved ? employe.pointage : draftPointage;
    if (!pointage) {
      // Un seul sélecteur discret à trois choix, sans icône, au lieu de trois
      // boutons de couleur par ligne (51 boutons pour 17 personnes, relevé le
      // 14/10/2026). Le choix fait prend sa couleur dans la ligne suivante.
      const choisir = (statut) => {
        const now = new Date();
        setPointagesBatch(prev => [...prev, statut === 'present'
          ? { employe_id: employe.id, timestamp: now.toISOString(), heure: now.toTimeString().slice(0, 5), statut, observations: '' }
          : { employe_id: employe.id, timestamp: null, heure: null, statut, observations: '' }]);
      };
      return (
        <div className="inline-flex rounded-lg border border-gray-200 bg-gray-50 p-0.5">
          {[['present', 'Présent'], ['absent', 'Absent'], ['jour_non_travaille', 'Non travaillé']].map(([statut, libelle]) => (
            <button key={statut} type="button" onClick={() => choisir(statut)} className="rounded-md px-3 py-1 text-xs font-medium text-gray-600 transition-colors hover:bg-white hover:text-gray-900 hover:shadow-sm">
              {libelle}
            </button>
          ))}
        </div>
      );
    }
    const presence = getPresenceMeta(pointage.statut);
    const PresenceIcon = presence.Icon;
    const plannedStart = formatHourValue(pointage.heure_debut_prevue);
    const plannedEnd = formatHourValue(pointage.heure_fin_prevue);
    const arrival = formatHourValue(pointage.heure_arrivee || pointage.heure);
    const departure = formatHourValue(pointage.heure_depart);
    const effectiveStart = formatHourValue(pointage.heure_arrivee_effective);
    const effectiveEnd = formatHourValue(pointage.heure_depart_effective);
    // La pause ne s'affiche que si elle a ete badgee : en mode automatique les
    // deux colonnes restent vides et la ligne n'aurait rien a dire.
    const pauseSortie = formatHourValue(pointage.heure_pause_sortie);
    const pauseRetour = formatHourValue(pointage.heure_pause_retour);
    const pauseBadgee = pauseSortie !== '-' || pauseRetour !== '-';
    return (
      <div className="space-y-2 min-w-[260px]">
        <div className="flex items-center gap-2">
          <span className={'inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium ' + presence.className}><PresenceIcon className="w-3 h-3 mr-1" />{presence.label}</span>
          {!saved && <button onClick={() => { setPointagesBatch(prev => prev.filter(p => p.employe_id !== employe.id)); setNotesOuvertes(prev => { const suivant = new Set(prev); suivant.delete(employe.id); return suivant; }); }} className="text-gray-400 hover:text-gray-600" title="Annuler"><X className="w-4 h-4" /></button>}
        </div>
        {saved ? (
          // Les heures s'alignent d'une ligne à l'autre : libellé de largeur
          // fixe, puis deux cases d'heure de même largeur en chiffres tabulaires
          // (demande de Daniel du 14/10/2026 : « d'autres sont longs, d'autres
          // courts »). Une heure absente garde sa case, marquée d'un tiret.
          //
          // « Compté » (ex « Effectif RH ») : les heures retenues pour la durée
          // après application des tolérances - une arrivée à 07:10 dans la
          // tolérance compte 07:00, un départ après l'heure compte l'heure de
          // fin. Montré seulement quand il diffère du pointage : identique, il
          // répétait la ligne du dessus.
          <div className="text-xs text-gray-600 grid grid-cols-[96px_auto] gap-x-3 gap-y-1 items-baseline">
            <span>Prévu</span>{plageHoraire(plannedStart, plannedEnd)}
            <span>Pointage</span>{plageHoraire(arrival, departure)}
            {pauseBadgee && <><span>Pause</span>{plageHoraire(pauseSortie, pauseRetour, 'en cours')}</>}
            {(effectiveStart !== arrival || effectiveEnd !== departure) && (effectiveStart !== '-' || effectiveEnd !== '-') && (
              <><span title="Heures retenues pour la durée, après application des tolérances">Compté</span>{plageHoraire(effectiveStart, effectiveEnd)}</>
            )}
            {pointage.cree_par_nom && <><span>Enregistré par</span><span className="font-medium text-gray-800">{pointage.cree_par_nom}{pointage.heure_enregistrement ? ' à ' + formatHourValue(pointage.heure_enregistrement) : ''}</span></>}
          </div>
        ) : <div className="text-xs text-gray-500">Pointage en cours de saisie : {formatHourValue(pointage.heure)}</div>}
        {saved && peutSaisirDepart(pointage) && (departsBatch[employe.id] ? (
          <div className="flex items-center gap-2 text-xs">
            <span className="text-gray-600">Départ saisi</span>
            <input
              type="time"
              value={departsBatch[employe.id].heure}
              onChange={(e) => modifierDepart(employe.id, e.target.value)}
              aria-label={`Heure de départ de ${employe.prenom || ''} ${employe.nom || ''}`}
              className="h-8 rounded-lg border border-gray-200 px-2 text-xs focus:border-[#246990] focus:ring-2 focus:ring-[#246990]/15"
            />
            <button type="button" onClick={() => retirerDepart(employe.id)} className="text-gray-400 hover:text-gray-600" title="Annuler le départ"><X className="w-4 h-4" /></button>
          </div>
        ) : (
          <button type="button" onClick={() => ajouterDepart(employe.id, pointage.id)} className="text-xs font-medium text-[#246990] hover:underline">
            Saisir le départ
          </button>
        ))}
        {/* La colonne Observations est partie le 14/10/2026 : un champ grisé
            sur chaque ligne déjà enregistrée. La note se lit ici ; elle se
            saisit, pendant la saisie seulement, derrière un lien. */}
        {saved && pointage.observations && (
          <p className="max-w-[340px] whitespace-pre-line text-xs italic text-gray-500">{pointage.observations}</p>
        )}
        {!saved && (notesOuvertes.has(employe.id) || pointage.observations) ? (
          <input
            type="text"
            autoFocus={noteAFocaliser === employe.id}
            onFocus={() => { if (noteAFocaliser === employe.id) setNoteAFocaliser(null); }}
            placeholder="Note sur ce pointage…"
            value={pointage.observations || ''}
            onChange={(e) => setPointagesBatch(prev => prev.map(p => p.employe_id === employe.id ? { ...p, observations: e.target.value } : p))}
            className="w-full max-w-[300px] rounded-lg border border-gray-300 px-2 py-1 text-xs focus:border-transparent focus:ring-2 focus:ring-[#246990]"
          />
        ) : !saved && (
          <button type="button" onClick={() => { setNotesOuvertes(prev => new Set(prev).add(employe.id)); setNoteAFocaliser(employe.id); }} className="text-xs font-medium text-[#246990] hover:underline">
            Ajouter une note
          </button>
        )}
      </div>
    );
  };

  const renderRhDurationCell = (pointage, employe = null, enregistre = false) => {
    if (!pointage) return <span className="text-xs text-gray-400">-</span>;
    const rh = getRhMeta(pointage);
    const anomalies = getAnomalieLabels(pointage);
    // « Justifier » vit ici, avec l'anomalie qu'il traite, et non dans la
    // colonne Comptabilité : celle-ci n'existe que si la paie est ouverte, et
    // la justification relève des RH. Seulement sur une ligne enregistrée.
    const aJustifier = enregistre && requiresRhJustification(pointage) && pointage.statut_comptabilite === 'en_attente';
    return (
      <div className="space-y-2 min-w-[170px]">
        <div className="text-sm font-semibold text-gray-900">{formatDurationFromMinutes(pointage.duree_effective_minutes)}</div>
        {rh && <span className={'inline-flex px-2.5 py-1 rounded-lg text-xs font-medium ' + rh.className}>{rh.label}</span>}
        {anomalies.length > 0 && <div className="flex flex-wrap gap-1">{anomalies.map((label, index) => <span key={label + '-' + index} className="px-2 py-0.5 rounded-lg bg-orange-50 text-orange-700 text-[11px] border border-orange-100">{label}</span>)}</div>}
        {pointage.justification_rh && ['justifie', 'corrige'].includes(pointage.statut_rh) && (
          <p className="max-w-[260px] text-xs text-gray-500">{pointage.justification_rh}{pointage.corrige_par_nom ? ' - ' + pointage.corrige_par_nom : ''}</p>
        )}
        {renderActionRh(pointage, employe, enregistre, aJustifier)}
      </div>
    );
  };

  // L'action RH de la ligne, selon ce que le serveur accepte (revue du
  // 14/10/2026) - une seule à la fois, ou une phrase qui dit pourquoi aucune :
  //  - ligne encore à l'heure de Paris : rien avant le rattrapage ;
  //  - sans la clé POINTAGES.ANOMALIES.JUSTIFIER : le dire ;
  //  - anomalie ouverte, journée terminée : « Justifier » (les deux gestes) ;
  //  - anomalie ouverte, journée en cours : « Corriger l'heure » seulement,
  //    avec le départ - la justification attend la fin de la journée ;
  //  - sans anomalie ouverte mais à reprendre (départ oublié d'un jour passé,
  //    ou ligne déjà justifiée ou corrigée) : « Corriger l'heure ».
  const renderActionRh = (pointage, employe, enregistre, aJustifier) => {
    if (!enregistre || pointage.statut_comptabilite !== 'en_attente') return null;
    // Saisie à la main en attente : seule la décision du Centre de Support la
    // fait avancer. Le départ, lui, se saisit dans la colonne du pointage.
    if (enValidation(pointage)) {
      return <p className="max-w-[220px] text-xs text-gray-500">En attente de la décision du Centre de Support.</p>;
    }
    const departOublie = !pointage.journee_ouverte && Boolean(pointage.heure_arrivee || pointage.heure) && !pointage.heure_depart
      && !['absent', 'jour_non_travaille'].includes(pointage.statut);
    const aReprendre = ['justifie', 'corrige'].includes(pointage.statut_rh);
    const corrigeable = aJustifier || departOublie || aReprendre;
    if (!corrigeable) return null;

    const texte = (contenu) => <p className="max-w-[220px] text-xs text-gray-500">{contenu}</p>;
    if (pointage.fuseau_a_recalculer) return texte("Heure de Paris : à reprendre après le rattrapage.");
    if (!peutJustifier) return aJustifier ? texte('Justification réservée aux personnes habilitées.') : null;

    const ouvrir = (corrigerSeulement) => {
      setSeulementCorriger(corrigerSeulement);
      setAnomalieAJustifier({ employe, pointage });
    };
    if (aJustifier && !pointage.journee_ouverte) {
      return (
        <button type="button" onClick={() => ouvrir(false)} className="h-8 w-[150px] rounded-lg border border-orange-300 bg-white px-3 text-xs font-semibold text-orange-700 transition-colors hover:bg-orange-50">
          Justifier
        </button>
      );
    }
    return (
      <div className="space-y-1">
        {aJustifier && pointage.journee_ouverte && texte('Justifiable une fois la journée terminée.')}
        <button type="button" onClick={() => ouvrir(true)} className="text-xs font-semibold text-[#246990] hover:underline">
          {departOublie ? 'Corriger : départ non badgé' : "Corriger l'heure"}
        </button>
      </div>
    );
  };

  const renderBatchSection = ({ categoryKey, title, subtitle, Icon, accentClass, headerClass, employees }) => (
    <div className="mb-4 border border-gray-200 rounded-lg overflow-hidden">
      <button onClick={() => setCategorieActive(categorieActive === categoryKey ? '' : categoryKey)} className={'w-full flex items-center justify-between p-4 transition-all ' + headerClass}>
        <div className="flex items-center"><div className={'w-10 h-10 rounded-full text-white flex items-center justify-center mr-3 ' + accentClass}><Icon size={20} /></div><div className="text-left"><h3 className="font-semibold text-gray-900 text-lg">{title}</h3><p className="text-sm text-gray-600">{subtitle}</p></div></div>
        {categorieActive === categoryKey ? <ChevronUp className="w-5 h-5 text-[#246990]" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
      </button>
      {categorieActive === categoryKey && (
        <div className="overflow-x-auto"><table className="w-full"><thead className="bg-gray-50 border-b border-gray-200"><tr><th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Employé</th><th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Pointage</th><th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Durée / RH</th>{paieOuverte && <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Comptabilité</th>}</tr></thead><tbody className="divide-y divide-gray-200">
          {employees.length === 0 ? <tr><td colSpan={paieOuverte ? 4 : 3} className="px-4 py-8 text-center text-gray-500"><Icon className="w-12 h-12 mx-auto mb-2 text-gray-300" /><p className="text-sm">Aucune donnée trouvée</p></td></tr> : employees.map((employe) => {
            const draftPointage = pointagesBatch.find(p => p.employe_id === employe.id);
            const savedPointage = employe.deja_pointe ? employe.pointage : null;
            const pointageForRh = savedPointage || draftPointage;
            return (
              <tr key={employe.id} className="hover:bg-gray-50 align-top"><td className="px-4 py-3"><div className="flex items-center"><div className={'w-8 h-8 rounded-full text-white flex items-center justify-center mr-3 ' + accentClass}><User size={16} /></div><div><div className="text-sm font-medium text-gray-900">{employe.prenom} {employe.nom}</div><div className="text-xs text-gray-500">{employe.role_nom || '-'}</div></div></div></td><td className="px-4 py-3">{renderPointageBatchDetails(employe, draftPointage)}</td><td className="px-4 py-3">{renderRhDurationCell(pointageForRh, employe, Boolean(savedPointage))}</td>{paieOuverte && <td className="px-4 py-3">{renderComptabiliteEmploye(savedPointage)}</td>}</tr>
            );
          })}
        </tbody></table></div>
      )}
    </div>
  );

  // Ce que « Tout envoyer en compta » enverrait pour la date affichée : la même
  // règle que le bouton d'une ligne (enregistrée, en attente, sans anomalie à
  // justifier). Le serveur la revérifie.
  //
  // Seules comptent les lignes DE LA DATE AFFICHÉE : pendant un changement de
  // jour, `employesBatch` garde un instant les lignes de la date précédente.
  // Une ligne encore à l'heure de Paris, ou une journée en cours (arrivée sans
  // départ, aujourd'hui), ne part pas : le serveur les écarte, l'écran le dit.
  const etatEnvoiLot = (() => {
    const dateAffichee = formatDateForAPI(selectedDate);
    const enregistres = employesBatch
      .filter(e => e.deja_pointe && e.pointage && e.pointage.statut_comptabilite === 'en_attente' && e.pointage.date_pointage === dateAffichee)
      .map(e => e.pointage);
    // Une saisie à la main en attente du Centre de Support ne part pas : le
    // serveur l'écarte (03/11/2026), l'écran le dit d'abord.
    const enAttenteSupport = enregistres.filter(p => enValidation(p));
    const aJustifier = enregistres.filter(p => !enValidation(p) && requiresRhJustification(p));
    const aRecalculer = enregistres.filter(p => !enValidation(p) && !requiresRhJustification(p) && p.fuseau_a_recalculer);
    const ouvertes = enregistres.filter(p => !enValidation(p) && !requiresRhJustification(p) && !p.fuseau_a_recalculer && p.journee_ouverte);
    const prets = enregistres.filter(p => !enValidation(p) && !requiresRhJustification(p) && !p.fuseau_a_recalculer && !p.journee_ouverte);
    return {
      total: enregistres.length,
      prets,
      aJustifier: aJustifier.length,
      retenus: [
        { libelle: 'en validation au Centre de Support', nombre: enAttenteSupport.length },
        { libelle: 'en attente de justification', nombre: aJustifier.length },
        { libelle: "encore à l'heure de Paris (en attente du rattrapage)", nombre: aRecalculer.length },
        { libelle: 'journée(s) en cours, départ pas encore badgé', nombre: ouvertes.length }
      ].filter(r => r.nombre > 0),
      sansDepart: prets.filter(p => !['absent', 'jour_non_travaille'].includes(p.statut) && (p.heure_arrivee || p.heure) && !p.heure_depart).length
    };
  })();

  const nombreDepartsSaisis = Object.keys(departsBatch).length;
  const saisieAValider = nombreDepartsSaisis > 0 || pointagesBatch.some((p) => p.statut !== 'absent');

  const attendanceStatus = calculateStatus();

  const getSectionColors = (sectionName) => {
    const colors = {
      'Préscolaire': { primary: '#F59E0B', secondary: '#FEF3C7', light: '#FFFBEB' },
      'Primaire': { primary: '#10B981', secondary: '#A7F3D0', light: '#ECFDF5' },
      'Collège': { primary: '#3B82F6', secondary: '#BFDBFE', light: '#EFF6FF' },
      'Lycée': { primary: '#8B5CF6', secondary: '#C4B5FD', light: '#F5F3FF' },
      'default': { primary: '#6B7280', secondary: '#E5E7EB', light: '#F9FAFB' }
    };
    return colors[sectionName] || colors.default;
  };



// Charger les pointages déjà enregistrés pour cette date
const loadPointagesExistants = async () => {
  try {
    const dateForAPI = formatDateForAPI(selectedDate);
    const pointagesRes = await api.pointages.getByDate(dateForAPI);

    if (pointagesRes.success) {
      setPointagesExistants(pointagesRes.data);

      //  CORRECTION : Vérifier uniquement si la classe est sélectionnée
      if (selectedTeacher && selectedClass) {
        const pointageEnCoursFound = pointagesRes.data.find(p =>
          p.enseignant_id === parseInt(selectedTeacher) &&
          p.affectation_id === parseInt(selectedClass) && //  Vérifier affectation_id
          p.heure_pointage_debut_reelle &&
          !p.heure_pointage_fin_reelle
        );

        if (pointageEnCoursFound) {
          setPointageEnCours({
            id: pointageEnCoursFound.id,
            enseignant_id: pointageEnCoursFound.enseignant_id,
            affectation_id: pointageEnCoursFound.affectation_id,
            arrivalTime: pointageEnCoursFound.heure_arrivee,
            timestampDebut: pointageEnCoursFound.heure_pointage_debut_reelle
          });

          setArrivalTime(pointageEnCoursFound.heure_arrivee);
          setTimestampDebut(pointageEnCoursFound.heure_pointage_debut_reelle);
        } else {
          //  Réinitialiser si pas de pointage en cours pour cette classe
          setPointageEnCours(null);
          setArrivalTime('');
          setTimestampDebut(null);
        }
      }
    } else {
      setPointagesExistants([]);
    }
  } catch (error) {
    console.error('Erreur chargement pointages existants:', error);
    setPointagesExistants([]);
  }
};



// Vérifier si un pointage COMPLET existe déjà pour cet enseignant/classe/date
const pointageExiste = (enseignantId, affectationId) => {
  return pointagesExistants.some(p =>
    p.enseignant_id === parseInt(enseignantId) &&
    p.affectation_id === parseInt(affectationId) &&
    (
      // Pointage complet
      (p.heure_pointage_debut_reelle && p.heure_pointage_fin_reelle) ||
      // OU absence enregistrée
      (['absent', 'jour_non_travaille'].includes(p.statut) || ['absent', 'jour_non_travaille'].includes(p.statut_debut))
    )
  );
};


  /*if (isLoading) {
    return (
      <div className="w-full min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#246990] mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement des données...</p>
        </div>
      </div>
    );
  }*/





  return (
    <div className="w-full min-h-screen bg-gray-50">
      <div className="w-full max-w-none p-6">
        {/* En-tête avec navigation de dates - Style VariableElements */}
        <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm mb-6">
          <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
            <div className="p-2 bg-[#246990] rounded-full mr-4">
              <Clock className="text-white" size={20} />
            </div>
            <div className="flex-1">
              <h1 className="font-medium text-[#246990] text-xl">Carnet de Pointage Manuel</h1>
              <p className="text-sm text-gray-600">Gestion des présences des enseignants et du personnels administratifs</p>
            </div>
            <div className="text-right">
              <div className="text-sm text-gray-500">Période active</div>
              <div className="font-medium text-gray-800">
                {getCurrentDate()}
              </div>
              <div className="text-xs text-gray-500">
                {viewMode === 'pointage' ? 'Pointage en cours' : 'Consultation historique'}
              </div>
            </div>
          </div>

          {/* Navigation et modes */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {/* Sélecteur de mode */}
              <div className="flex bg-gray-100 rounded-lg p-1">
                <button
                  onClick={() => setViewMode('pointage')}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    viewMode === 'pointage'
                      ? 'bg-white text-[#246990] shadow-sm'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <Clock className="w-4 h-4 mr-2 inline" />
                  Pointage
                </button>
                <button
                  onClick={() => setViewMode('historique')}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    viewMode === 'historique'
                      ? 'bg-white text-[#246990] shadow-sm'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <History className="w-4 h-4 mr-2 inline" />
                  Historique
                </button>
              </div>
            </div>

            {/* Navigation de dates */}
            <div className="flex items-center space-x-2 bg-gray-50 rounded-lg p-2">
              <button
                onClick={goToPreviousDay}
                className="p-2 text-gray-600 hover:text-gray-900 hover:bg-white rounded-md transition-colors"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>

              <div className="relative">
                <button
                  onClick={() => setShowCalendar(!showCalendar)}
                  className="flex items-center px-4 py-2 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors"
                >
                  <Calendar className="h-4 w-4 mr-2 text-[#246990]" />
                  <span className="text-sm font-medium text-gray-900">
                    {formatDateForDisplay(selectedDate)}
                  </span>
                </button>

                {showCalendar && (
                  <div className="absolute top-full mt-2 right-0 bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-4">
                    <input
                      type="date"
                      value={formatDateForAPI(selectedDate)}  // ← Changement ici
                      onChange={(e) => {
                        const newDate = new Date(e.target.value + 'T12:00:00');  // ← Midi pour éviter décalage
                        setSelectedDate(newDate);
                        setShowCalendar(false);
                      }}
                      className="p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                )}
              </div>

              <button
                onClick={goToNextDay}
                className="p-2 text-gray-600 hover:text-gray-900 hover:bg-white rounded-md transition-colors"
              >
                <ChevronRight className="w-4 h-4" />
              </button>

              <button
                onClick={goToToday}
                className="px-3 py-2 text-xs bg-[#246990] text-white rounded-md hover:bg-[#1f5a7a] transition-colors"
              >
                Aujourd'hui
              </button>
            </div>
          </div>
        </div>

        {viewMode === 'pointage' ? (
          <div className="space-y-6">
            {/* Toggle mode de pointage */}
            <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">Mode de pointage</h3>
                  <p className="text-sm text-gray-600">Choisissez entre pointage individuel ou par lot</p>
                </div>
                <div className="flex bg-gray-100 rounded-lg p-1">
                  <button
                    onClick={() => {
                      setBatchMode(false);
                      //resetBatchForm();
                    }}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                      !batchMode
                        ? 'bg-white text-[#246990] shadow-sm'
                        : 'text-gray-600 hover:text-gray-900'
                    }`}
                  >
                    Individuel
                  </button>
                  <button
                    onClick={() => {
                      setBatchMode(true);
                      resetForm();
                    }}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                      batchMode
                        ? 'bg-white text-[#246990] shadow-sm'
                        : 'text-gray-600 hover:text-gray-900'
                    }`}
                  >
                    Par lot
                  </button>
                </div>
              </div>
            </div>



            {!batchMode ? (
              /* Mode Pointage Individuel */
              <div className="space-y-6">
                {/* Grille principale des sections */}
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-6">



                {/* Section 1: Enseignants avec recherche */}
                    <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                      <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
                        <div className="p-2 bg-[#246990] rounded-full mr-3">
                          <User className="text-white" size={16} />
                        </div>
                        <div className="flex-1">
                          <h2 className="font-medium text-[#246990] text-lg">Enseignant horaire</h2>
                          <p className="text-sm text-gray-600">Recherche et sélection</p>
                        </div>
                      </div>

                      <div className="relative">
                        {/* Champ de recherche */}
                        <div className="relative">
                          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                          <input
                            type="text"
                            placeholder="Rechercher un enseignant..."
                            value={(() => {
                              const selectedTeacherData = enseignants.find(t => t.id.toString() === selectedTeacher);
                              return selectedTeacherData ? `${selectedTeacherData.nom} ${selectedTeacherData.prenom}` : teacherSearchTerm;
                            })()}
                            onChange={(e) => {
                              setTeacherSearchTerm(e.target.value);
                              if (selectedTeacher) {
                                setSelectedTeacher('');
                                setSelectedSection('');
                                setSelectedClass('');
                              }
                            }}
                            className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                          />
                          {selectedTeacher && (
                            <button
                              onClick={() => {
                                setSelectedTeacher('');
                                setSelectedSection('');
                                setSelectedClass('');
                                setTeacherSearchTerm('');
                              }}
                              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                            >
                              <X className="w-4 h-4" />
                            </button>
                          )}
                        </div>

                        {/* Dropdown avec autocomplétion */}
                        {teacherSearchTerm && !selectedTeacher && (
                          <div className="absolute top-full mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-64 overflow-y-auto">
                            {(() => {
                              const filteredEnseignants = enseignants.filter(teacher =>
                                `${teacher.nom} ${teacher.prenom}`.toLowerCase().includes(teacherSearchTerm.toLowerCase()) ||
                                teacher.sections?.some(s => s.nom.toLowerCase().includes(teacherSearchTerm.toLowerCase()))
                              );

                              return filteredEnseignants.length > 0 ? (
                                filteredEnseignants.map((teacher) => (
                                  <div
                                    key={teacher.id}
                                    onClick={() => {
                                      setSelectedTeacher(teacher.id.toString());
                                      setTeacherSearchTerm('');
                                      setSelectedSection('');
                                      setSelectedClass('');
                                    }}
                                    className="p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                                  >
                                    <div className="flex items-center">
                                      <div className="w-10 h-10 rounded-full bg-[#246990] text-white flex items-center justify-center mr-3">
                                        <User size={18} />
                                      </div>
                                      <div className="flex-1">
                                        <div className="font-medium text-gray-900">
                                          {teacher.nom} {teacher.prenom}
                                        </div>
                                        <div className="text-xs text-gray-500">
                                          {teacher.sections?.map(s => s.nom).join(', ') || 'Aucune section'}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="p-3 text-center text-gray-500">
                                  <Search className="w-8 h-8 mx-auto mb-2 opacity-50" />
                                  <p className="text-sm">Aucun enseignant trouvé</p>
                                </div>
                              );
                            })()}
                          </div>
                        )}

                        {/* Enseignant sélectionné */}
                        {selectedTeacher && (() => {
                          const selectedTeacherData = enseignants.find(t => t.id.toString() === selectedTeacher);
                          return selectedTeacherData ? (
                            <div className="mt-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
                              <div className="flex items-center">
                                <div className="w-10 h-10 rounded-full bg-[#246990] text-white flex items-center justify-center mr-3">
                                  <User size={18} />
                                </div>
                                <div className="flex-1">
                                  <div className="text-sm text-blue-700 font-medium">
                                    {selectedTeacherData.prenom} {selectedTeacherData.nom}
                                  </div>
                                  <div className="text-xs text-blue-600 mt-1">
                                    Sections : {selectedTeacherData.sections?.map(s => s.nom).join(', ')}
                                  </div>
                                </div>
                                <button
                                  onClick={() => {
                                    setSelectedTeacher('');
                                    setSelectedSection('');
                                    setSelectedClass('');
                                    setTeacherSearchTerm('');
                                  }}
                                  className="text-blue-600 hover:text-blue-800"
                                >
                                  <X className="w-4 h-4" />
                                </button>
                              </div>
                            </div>
                          ) : null;
                        })()}
                      </div>
                    </div>


                  {/* Section 2: Sections */}
                  <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                    <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
                      <div className="p-2 bg-[#246990] rounded-full mr-3">
                        <BookOpen className="text-white" size={16} />
                      </div>
                      <div className="flex-1">
                        <h2 className="font-medium text-[#246990] text-lg">Section</h2>
                        <p className="text-sm text-gray-600">Choix de section</p>
                      </div>
                    </div>

                    {!selectedTeacher ? (
                      <div className="text-center py-8 text-gray-400">
                        <BookOpen className="h-12 w-12 mx-auto mb-2 opacity-50" />
                        <p className="text-sm">Sélectionnez d'abord un enseignant</p>
                      </div>
                    ) : (
                      <>
                        <div className="mb-3 p-2 bg-yellow-50 border border-yellow-200 rounded-lg">
                          <p className="text-xs text-yellow-700">
                            Les sections affichées sont uniquement celles dans lesquelles l'enseignant sélectionné a des classes affectées.
                          </p>
                        </div>

                        {/* La liste déroulante de la charte (ChampSelect), plus un
                            <select> natif (03/11/2026). La section reste une chaîne,
                            comparée plus bas à `s.id.toString()`. */}
                        <ChampSelect
                          // Remonté quand la section est vidée (autre enseignant) :
                          // sans valeur, Radix garderait le dernier choix affiché.
                          key={selectedSection ? 'section-choisie' : 'section-vide'}
                          valeur={selectedSection || undefined}
                          onChange={(valeur) => {
                            setSelectedSection(valeur);
                            setSelectedClass('');
                          }}
                          options={getAvailableSections().map((section) => ({ valeur: section.id, libelle: section.nom }))}
                          placeholder="Choisir une section"
                        />


                        {selectedSection && (() => {
                          const section = getAvailableSections().find(s => s.id.toString() === selectedSection);
                          const colors = getSectionColors(section?.nom);
                          return (
                            <div className="mt-3 p-3 rounded-lg border" style={{ backgroundColor: colors.light, borderColor: colors.primary }}>
                              <div className="text-sm font-medium" style={{ color: colors.primary }}>
                                Section: {section?.nom}
                              </div>
                              <div className="text-xs text-gray-600 mt-1">
                                {section?.classes.length} classe(s) disponible(s)
                              </div>
                            </div>
                          );
                        })()}
                      </>
                    )}
                  </div>

                  {/* Section 3: Classes & Heures */}
                    <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                      <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
                        <div className="p-2 bg-[#246990] rounded-full mr-3">
                          <Timer className="text-white" size={16} />
                        </div>
                        <div className="flex-1">
                          <h2 className="font-medium text-[#246990] text-lg">Classe</h2>
                          <p className="text-sm text-gray-600">Classes & horaires</p>
                        </div>
                      </div>

                      {!selectedSection ? (
                        <div className="text-center py-8 text-gray-400">
                          <Timer className="h-12 w-12 mx-auto mb-2 opacity-50" />
                          <p className="text-sm">Sélectionnez d'abord une section</p>
                        </div>
                      ) : (
                        <>
                          <div className="mb-3 p-2 bg-blue-50 border border-blue-200 rounded-lg">
                            <p className="text-xs text-blue-700">
                              Sélectionnez la classe et l'horaire pour le pointage ({formatDateForDisplay(selectedDate)})
                            </p>
                          </div>


                          {/* Cards des classes au lieu du select */}
                              <div className="space-y-3 max-h-80 overflow-y-auto">
                                {getAvailableClasses().length > 0 ? (
                                  getAvailableClasses().map((classe) => {
                                    const isSelected = selectedClass === classe.affectation_id.toString();
                                    const hasHoraire = classe.has_creneau;
                                    const isClickable = hasHoraire && classe.horaire !== "Pas de cours aujourd'hui";
                                    const section = getAvailableSections().find(s => s.id.toString() === selectedSection);
                                    const colors = getSectionColors(section?.nom);

                                    // Fonction pour formater l'horaire
                                    const formatHoraire = (horaire) => {
                                      if (!horaire) return '';
                                      return horaire
                                        .replace(/(\d{2}):(\d{2}):\d{2}/g, '$1h$2')  // 08:00:00 → 08h00
                                        .replace(/(\d{2}):(\d{2})/g, '$1h$2');       // 08:00 → 08h00
                                    };

                                    return (
                                      <div
                                        key={classe.id}
                                        onClick={() => {
                                          if (isClickable) {

                                            console.log("Sélection avec affectation_id:", classe.affectation_id);
                                            setSelectedClass(classe.affectation_id.toString());


                                          }
                                        }}
                                        className={`p-4 rounded-lg border-2 transition-all ${
                                          !isClickable
                                            ? 'border-gray-200 bg-gray-100 cursor-not-allowed opacity-60'
                                            : isSelected
                                              ? 'border-[#246990] bg-blue-50 shadow-md cursor-pointer'
                                              : 'border-gray-200 hover:border-gray-300 bg-white hover:shadow-sm cursor-pointer'
                                        }`}
                                      >
                                        <div className="flex items-center justify-between">
                                          <div className="flex-1">
                                            <div className={`font-medium ${
                                              !isClickable
                                                ? 'text-gray-500'
                                                : isSelected
                                                  ? 'text-[#246990]'
                                                  : 'text-gray-900'
                                            }`}>
                                              {classe.nom}
                                            </div>
                                            {classe.matiere && (
                                              <div className={`text-sm mt-1 ${
                                                !isClickable ? 'text-gray-400' : 'text-gray-600'
                                              }`}>
                                                {classe.matiere}
                                              </div>
                                            )}
                                          </div>

                                          <div className="flex items-center space-x-3">
                                            <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                                              !isClickable
                                                ? 'bg-gray-200 text-gray-500'
                                                : hasHoraire
                                                  ? 'bg-green-100 text-green-800'
                                                  : 'bg-gray-100 text-gray-600'
                                            }`}>
                                              {formatHoraire(classe.horaire)}
                                            </span>

                                            {isSelected && isClickable && (
                                              <div className="w-5 h-5 bg-[#246990] rounded-full flex items-center justify-center">
                                                <Check className="w-3 h-3 text-white" />
                                              </div>
                                            )}

                                            {!isClickable && (
                                              <div className="w-5 h-5 bg-gray-400 rounded-full flex items-center justify-center">
                                                <X className="w-3 h-3 text-white" />
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="text-center py-8 text-gray-400">
                                    <Timer className="h-12 w-12 mx-auto mb-2 opacity-50" />
                                    <p className="text-sm">Aucune classe disponible pour cette section</p>
                                  </div>
                                )}
                              </div>


                     {/* Résumé de la sélection */}
                    {selectedClass && (() => {
                     const classe = getAvailableClasses().find(c => c.affectation_id.toString() === selectedClass);
                      const section = getAvailableSections().find(s => s.id.toString() === selectedSection);
                      const colors = getSectionColors(section?.nom);

                      const formatHoraire = (horaire) => {
                        if (!horaire) return '';
                        return horaire
                          .replace(/(\d{2}):(\d{2}):\d{2}/g, '$1h$2')
                          .replace(/(\d{2}):(\d{2})/g, '$1h$2');
                      };

                      // Plus de vérification restrictive
                      if (!classe) return null;

                      return (
                        <div className="mt-4 p-3 rounded-lg border" style={{ backgroundColor: colors.light, borderColor: colors.primary }}>
                          <div className="flex items-center justify-between">
                            <div>
                              <div className="text-sm font-medium" style={{ color: colors.primary }}>
                                Sélection: {classe.nom}
                              </div>
                              <div className="text-xs text-gray-600 mt-1">
                                Horaire: {formatHoraire(classe.horaire)}
                                {classe.matiere && ` ${classe.matiere}`}
                              </div>
                            </div>
                            <div className="text-xs text-gray-500">
                              {classe.has_creneau ? 'Créneau programmé' : 'Pas de cours'}
                            </div>
                          </div>
                        </div>
                      );
                    })()}
                 </>
                      )}
                    </div>




                {/* Section 4: Pointage */}
                <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                  <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
                    <div className="p-2 bg-[#246990] rounded-full mr-3">
                      <CheckCircle className="text-white" size={16} />
                    </div>
                    <div className="flex-1">
                      <h2 className="font-medium text-[#246990] text-lg">Pointage</h2>
                      <p className="text-sm text-gray-600">Système de pointage en temps réel</p>
                    </div>
                  </div>


                  {!selectedClass ? (
                    <div className="text-center py-8 text-gray-400">
                      <CheckCircle className="h-12 w-12 mx-auto mb-2 opacity-50" />
                      <p className="text-sm">Sélectionnez d'abord une classe</p>
                    </div>
                  ) : (() => {
                    const selectedClassData = getAvailableClasses().find(c => c.affectation_id.toString() === selectedClass);
                    if (!selectedClassData) return null;

                    const dejaPointe = pointageExiste(selectedTeacher, selectedClass);
                    const pointageEnCoursActif = pointageEnCours &&
                      pointageEnCours.affectation_id.toString() === selectedClass;

                    if (dejaPointe) {
                      return (
                        <div className="text-center py-8">
                          <div className="w-16 h-16 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center">
                            <CheckCircle className="w-8 h-8 text-green-600" />
                          </div>
                          <h4 className="text-lg font-medium text-green-900 mb-2">Pointage effectué</h4>
                          <p className="text-sm text-gray-600">
                            Ce créneau a déjà été pointé pour cette date.
                          </p>
                        </div>
                      );
                    }

                    const horaireParts = selectedClassData.horaire.split(' - ');
                    const heureDebut = horaireParts[0]?.replace('h', ':');
                    const heureFin = horaireParts[1]?.replace('h', ':');

                    return (
                      <div className="space-y-4">

                        {/* Horloge temps réel */}
                      <div className="text-center p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="text-2xl font-mono font-bold text-gray-900">
                          {currentTime.toLocaleTimeString('fr-FR')}
                        </div>
                        <div className="text-sm text-gray-600 mt-1">
                          Heure actuelle du {currentTime.toLocaleDateString('fr-FR')}
                        </div>
                      </div>

                        {/* CAS 1: Aucun pointage commencé */}
                        {!pointageEnCoursActif && !arrivalTime && (
                          <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                            <div className="mb-3">
                              <h3 className="font-medium text-blue-900">Heure de début</h3>
                              <p className="text-sm text-blue-700">Prévue : {heureDebut}</p>
                            </div>

                            <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
                              <button
                                onClick={() => {
                                  const now = new Date();
                                  const timeString = now.toTimeString().slice(0, 5);
                                  setArrivalTime(timeString);
                                  setTimestampDebut(now.toISOString());
                                }}
                                className="py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 font-medium"
                              >
                                <CheckCircle className="w-4 h-4 inline mr-1" />
                                Présent
                              </button>

                              <button
                                onClick={handleMarquerAbsent}
                                className="py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 font-medium"
                              >
                                <X className="w-4 h-4 inline mr-1" />
                                Absent
                              </button>

                              <button
                                onClick={handleMarquerCreneauNonTravaille}
                                className="py-2 rounded-lg bg-gray-600 text-white hover:bg-gray-700 font-medium"
                              >
                                <CalendarX className="w-4 h-4 inline mr-1" />
                                Créneau non travaillé
                              </button>
                            </div>




                          </div>
                        )}

                        {!pointageEnCoursActif && ['ABSENT', 'NON_TRAVAILLE'].includes(arrivalTime) && (
                          <div className="p-4 rounded-lg border bg-amber-50 border-amber-200">
                            <div className="flex items-start gap-3">
                              <div className="mt-1 rounded-full bg-white p-2 text-amber-700">
                                {arrivalTime === 'ABSENT' ? <X className="w-5 h-5" /> : <CalendarX className="w-5 h-5" />}
                              </div>
                              <div className="flex-1">
                                <h3 className="font-medium text-amber-900">
                                  {arrivalTime === 'ABSENT' ? 'Absence à enregistrer' : 'Créneau non travaillé à enregistrer'}
                                </h3>
                                <p className="text-sm text-amber-700 mt-1">
                                  {arrivalTime === 'ABSENT'
                                    ? 'Ce créneau sera transmis comme absence avec une durée de 0 minute.'
                                    : 'Ce créneau sera transmis comme non travaillé avec une durée de 0 minute.'}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* CAS 2: Début pointé mais pas encore enregistré */}
                        {!pointageEnCoursActif && arrivalTime && !['ABSENT', 'NON_TRAVAILLE'].includes(arrivalTime) && (
                          <>
                            <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                              <div className="flex items-center justify-between mb-3">
                                <div>
                                  <h3 className="font-medium text-green-900">Heure de début</h3>
                                  <p className="text-sm text-green-700">Pointé à  : {arrivalTime}</p>
                                </div>
                                <CheckCircle className="w-6 h-6 text-green-600" />
                              </div>

                              <button
                                onClick={handleEnregistrerDebut}
                                disabled={loading}
                                className="w-full py-2 px-3 bg-[#246990] text-white rounded-lg hover:bg-[#1f5a7a] disabled:bg-gray-400 font-medium"
                              >
                                {loading ? (
                                  <>
                                    <Loader2 className="w-4 h-4 animate-spin inline mr-2" />
                                    Enregistrement...
                                  </>
                                ) : (
                                  'Enregistrer le début'
                                )}
                              </button>

                              <button
                                onClick={() => {
                                  setArrivalTime('');
                                  setTimestampDebut(null);
                                }}
                                className="w-full mt-2 py-2 text-sm text-gray-600 hover:text-gray-800"
                              >
                                Annuler
                              </button>
                            </div>
                          </>
                        )}

                        {/* CAS 3: Début enregistré, en attente de fin */}
                        {pointageEnCoursActif && (
                          <>
                            {/* Résumé du début enregistré */}
                            <div className="p-3 bg-green-50 rounded-lg border border-green-200">
                              <div className="flex items-center mb-2">
                                <CheckCircle className="w-5 h-5 text-green-600 mr-2" />
                                <span className="font-medium text-green-900">Début enregistré</span>
                              </div>
                              <div className="text-sm text-green-700">
                                Pointé à  : {pointageEnCours.arrivalTime}
                              </div>
                              <div className="mt-2 p-2 bg-yellow-50 border border-yellow-200 rounded">
                                <p className="text-xs text-yellow-700">
                                  En attente du pointage de fin
                                </p>
                              </div>
                            </div>

                            {/* Pointage de fin */}
                            <div className="p-4 bg-purple-50 rounded-lg border border-purple-200">
                              <div className="mb-3">
                                <h3 className="font-medium text-purple-900">Heure de fin</h3>
                                <p className="text-sm text-purple-700">Prévue : {heureFin}</p>
                              </div>

                              {!departureTime ? (
                                <div className="flex gap-2">
                                  <button
                                    onClick={() => {
                                      const now = new Date();
                                      const timeString = now.toTimeString().slice(0, 5);
                                      setDepartureTime(timeString);
                                      setTimestampFin(now.toISOString());
                                    }}
                                    className="flex-1 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 font-medium"
                                  >
                                    <CheckCircle className="w-4 h-4 inline mr-1" />
                                    Présent
                                  </button>
                                  <button
                                  onClick={handleMarquerAbsent}
                                  className="flex-1 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 font-medium"
                                >
                                  <X className="w-4 h-4 inline mr-1" />
                                  Absent
                                </button>
                                </div>
                              ) : (
                                <>
                                  <div className="p-3 bg-white rounded-lg border mb-3">
                                    <div className="flex items-center justify-between">
                                      <span className="text-sm text-purple-700">Pointé à  :</span>
                                      <span className="font-medium text-purple-900">{departureTime}</span>
                                    </div>
                                  </div>

                              <button
                                onClick={() => {
                                  setHeureFinValidee(true);
                                  setToast({
                                    show: true,
                                    message: 'Heure de fin validée ! Cliquez sur "Enregistrer le pointage" en bas pour finaliser.',
                                    type: 'success'
                                  });
                                }}
                                disabled={heureFinValidee}
                                className={`w-full py-2 px-3 rounded-lg font-medium transition-colors ${
                                  heureFinValidee
                                    ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                                    : 'bg-[#246990] text-white hover:bg-[#1f5a7a]'
                                }`}
                              >
                                {heureFinValidee ? 'Heure de fin validée' : 'Valider l\'heure de fin'}
                              </button>

                                  <button
                                    onClick={() => {
                                      setDepartureTime('');
                                      setTimestampFin(null);
                                    }}
                                    className="w-full mt-2 py-2 text-sm text-gray-600 hover:text-gray-800"
                                  >
                                    Annuler
                                  </button>
                                </>



                              )}
                            </div>
                          </>
                        )}
                      </div>
                    );
                  })()}
                </div>



                </div>

                {/* Section 5: Observations - Sur toute la largeur */}
                <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                  <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
                    <div className="p-2 bg-[#246990] rounded-full mr-4">
                      <FileText className="text-white" size={20} />
                    </div>
                    <div className="flex-1">
                      <h2 className="font-medium text-[#246990] text-xl">Observations</h2>
                      <p className="text-sm text-gray-600">Remarques et justifications</p>
                    </div>
                  </div>

                  <textarea
                    value={observations}
                    onChange={(e) => setObservations(e.target.value)}
                    placeholder="Remarques, justifications, observations particulières..."
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                    rows="3"
                  />

                  <div className="flex justify-between items-center mt-6">
                    <div className="flex space-x-3">
                      <button
                        onClick={resetForm}
                        className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
                      >
                        Réinitialiser
                      </button>
                    </div>

                    <button
                      onClick={() => {
                        if (arrivalTime === 'ABSENT') {
                          handleAbsent();
                        } else if (arrivalTime === 'NON_TRAVAILLE') {
                          handleCreneauNonTravaille();
                        } else if (pointageEnCours && departureTime && !['ABSENT', 'NON_TRAVAILLE'].includes(departureTime)) {
                          handleCompleterPointage();
                        } else {
                          handleSavePointage();
                        }
                      }}
                      disabled={loading || !selectedTeacher || !selectedClass || !arrivalTime}
                      className="flex items-center px-8 py-2 bg-[#246990] text-white rounded-lg hover:bg-[#1f5a7a] disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
                    >
                      {loading ? (
                        <>
                          <Loader2 className="w-4 h-4 animate-spin mr-2" />
                          Enregistrement...
                        </>
                      ) : arrivalTime === 'ABSENT' ? (
                        "Enregistrer l'absence"
                      ) : arrivalTime === 'NON_TRAVAILLE' ? (
                        'Enregistrer le créneau non travaillé'
                      ) : pointageEnCours ? (
                        'Enregistrer le pointage complet'
                      ) : (
                        'Enregistrer le pointage'
                      )}
                    </button>
                  </div>
                </div>
              </div>
            ) : (


          /* Mode Pointage Par Lot - personnel fixe et administratif */
          <div className="space-y-6">
            <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
              <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
                <div className="p-2 bg-[#246990] rounded-full mr-4"><Users className="text-white" size={20} /></div>
                <div className="flex-1"><h2 className="font-medium text-[#246990] text-xl">Personnel administratif et enseignant fixe</h2><p className="text-sm text-gray-600">Historique et saisie des pointages par lot. Les durées et anomalies RH sont calculées depuis les paramètres de pointage.</p>
                  {/* Le fonctionnement de la saisie manuelle, d'un coup d'œil (demande
                      de Daniel du 03/11/2026) : ce qui la déclenche et ce qu'elle
                      devient. Ce qui bloque (le motif) est écrit en clair dans le
                      bandeau de saisie ; le badge n'en est que le complément. */}
                  <div className="mt-2">
                    <InfoBulle
                      titre="La saisie manuelle se valide au Centre de Support"
                      largeur="w-96"
                      alignement="start"
                      libelle="Comment fonctionne la saisie manuelle des pointages"
                      declencheur={(
                        <span
                          tabIndex={0}
                          className="inline-flex h-6 cursor-help items-center gap-1.5 rounded-lg border border-amber-200 bg-amber-50 px-2.5 text-xs font-medium text-amber-800 outline-none focus-visible:ring-2 focus-visible:ring-amber-300"
                        >
                          <Info className="h-3.5 w-3.5" />
                          Saisie manuelle validée au Centre de Support
                        </span>
                      )}
                    >
                      <p>La saisie à la main ne sert que si la borne ou le badge n'a pas marché.</p>
                      <ul className="mt-2 list-disc space-y-1 pl-4">
                        <li><span className="font-semibold text-gray-800">Présent, Non travaillé, Saisir le départ</span> : envoyés au Centre de Support avec un motif. La ligne reste « En validation » : elle ne part pas en comptabilité et n'est pas payée tant qu'elle n'est pas validée.</li>
                        <li><span className="font-semibold text-gray-800">Absent</span> : enregistré directement.</li>
                        <li><span className="font-semibold text-gray-800">Présent</span> n'enregistre que l'arrivée : le départ se badge à la borne, ou se saisit sur la ligne.</li>
                        <li><span className="font-semibold text-gray-800">Borne en panne</span> : cochez la case, et tout le lot part en une seule demande.</li>
                        <li><span className="font-semibold text-gray-800">Corriger l'heure</span> passe aussi par le Centre de Support.</li>
                        <li>Validée, la journée compte. Refusée, elle revient à son état d'avant, ou devient une absence à justifier. Retirée par celui qui l'a saisie, elle est effacée.</li>
                        <li>Celui qui saisit ne valide pas sa saisie, et personne ne valide son propre pointage.</li>
                        <li><span className="font-semibold text-gray-800">Alerte critique</span> au-delà de 3 saisies manuelles en 7 jours pour une même personne, ou de 10 pour un même agent.</li>
                      </ul>
                    </InfoBulle>
                  </div>
                </div>
                <div className="text-right text-sm text-gray-600"><div className="font-semibold text-gray-900">{employesBatch.length} employé(s)</div><div>{employesBatch.filter(e => e.groupe_nom !== 'Enseignant').length} personnel • {employesBatch.filter(e => e.groupe_nom === 'Enseignant').length} enseignant(s)</div></div>
              </div>
              <div className="text-center p-3 bg-gray-50 rounded-lg border border-gray-200 mb-5"><div className="text-2xl font-mono font-bold text-gray-900">{currentTime.toLocaleTimeString('fr-FR')}</div><div className="text-sm text-gray-600 mt-1">Heure actuelle du {currentTime.toLocaleDateString('fr-FR')}</div></div>
              {paieOuverte && etatEnvoiLot.total > 0 && (
                // « Tout envoyer en compta » (14/10/2026) : une barre, au-dessus
                // des deux sections, qui dit ce qui partira et ce qui attend.
                <div className="mb-5 flex flex-wrap items-center gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3">
                  <div className="flex-1 text-sm text-gray-700">
                    <span className="font-semibold text-gray-900">{etatEnvoiLot.prets.length} pointage(s) prêt(s) pour la comptabilité</span>
                    {etatEnvoiLot.retenus.map(({ libelle, nombre }) => <span key={libelle} className="text-orange-700"> - {nombre} {libelle}</span>)}
                  </div>
                  <button
                    type="button"
                    onClick={() => setConfirmationEnvoiLot(true)}
                    disabled={loading || envoiLotEnCours || etatEnvoiLot.prets.length === 0}
                    className="h-9 inline-flex items-center gap-2 rounded-lg bg-[#246990] px-4 text-sm font-semibold text-white transition-colors hover:bg-[#1f5a7a] disabled:cursor-not-allowed disabled:bg-gray-300"
                  >
                    {envoiLotEnCours ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                    Tout envoyer en compta
                  </button>
                </div>
              )}
              {renderBatchSection({ categoryKey: 'personnel', title: 'Personnel administratif', subtitle: employesBatch.filter(e => e.groupe_nom !== 'Enseignant').length + ' employé(s)', Icon: Users, accentClass: 'bg-[#246990]', headerClass: 'bg-gradient-to-r from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200', employees: employesBatch.filter(e => e.groupe_nom !== 'Enseignant') })}
              {renderBatchSection({ categoryKey: 'enseignants', title: 'Enseignants fixes', subtitle: employesBatch.filter(e => e.groupe_nom === 'Enseignant').length + ' enseignant(s)', Icon: GraduationCap, accentClass: 'bg-purple-600', headerClass: 'bg-gradient-to-r from-purple-50 to-purple-100 hover:from-purple-100 hover:to-purple-200', employees: employesBatch.filter(e => e.groupe_nom === 'Enseignant') })}
              {/* La saisie manuelle passe par le Centre de Support (03/11/2026) :
                  motif obligatoire, et la panne de borne qui fait du lot une
                  seule demande. « Absent » seul n'en demande pas. */}
              {saisieAValider && (
                <div className="mt-6 rounded-lg border border-amber-200 bg-amber-50 p-4">
                  <p className="text-sm font-semibold text-amber-900">Saisie manuelle : validation au Centre de Support</p>
                  <p className="mt-1 text-xs text-amber-800">
                    Les présences, jours non travaillés et départs saisis à la main ne comptent qu'une fois validés.
                    Plus de 3 saisies manuelles en 7 jours pour une même personne lèvent une alerte critique.
                  </p>
                  <div className="mt-3 grid gap-3 sm:grid-cols-2">
                    <div className="flex flex-col gap-1 text-xs text-gray-700">
                      <label htmlFor="motif-saisie-manuelle">Motif</label>
                      {/* La liste déroulante de la charte, jamais un <select> natif
                          (rendu par le système, ni stylable ni cohérent). */}
                      <ChampSelect
                        id="motif-saisie-manuelle"
                        // Remonté quand le motif est vidé (lot enregistré) : sans
                        // valeur, Radix garderait le dernier choix affiché.
                        key={motifSaisie ? 'motif-choisi' : 'motif-vide'}
                        valeur={motifSaisie || undefined}
                        onChange={setMotifSaisie}
                        options={MOTIFS_SAISIE_MANUELLE}
                        placeholder="Choisir le motif…"
                        className="!bg-white font-normal"
                      />
                    </div>
                    <div className="flex flex-col gap-1 text-xs text-gray-700">
                      <label htmlFor="commentaire-saisie-manuelle">Commentaire{motifSaisie === 'autre' ? ' (obligatoire)' : ''}</label>
                      <input
                        id="commentaire-saisie-manuelle"
                        type="text"
                        value={commentaireSaisie}
                        onChange={(e) => setCommentaireSaisie(e.target.value)}
                        placeholder="Précision pour le validateur"
                        className="h-9 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm focus:border-[#246990] focus:outline-none focus:ring-2 focus:ring-[#246990]/15"
                      />
                    </div>
                  </div>
                  <CaseACocher
                    checked={bornePanne}
                    onChange={setBornePanne}
                    label="Borne en panne"
                    description="Tout le lot part en une seule demande, qui ne compte pas dans l'alerte de chaque personne."
                    className="mt-3 rounded-lg bg-white"
                  />
                </div>
              )}
              <div className="flex justify-between items-center mt-6 pt-6 border-t border-gray-200"><div className="text-sm text-gray-600">{pointagesBatch.length} / {employesBatch.length} employé(s) pointé(s){nombreDepartsSaisis > 0 ? ` - ${nombreDepartsSaisis} départ(s) saisi(s)` : ''}</div><div className="flex gap-3"><button onClick={() => { setPointagesBatch([]); setDepartsBatch({}); }} className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors">Réinitialiser</button><button onClick={handleSaveBatchPointages} disabled={(pointagesBatch.length === 0 && nombreDepartsSaisis === 0) || loading} className="flex items-center px-8 py-2 bg-[#246990] text-white rounded-lg hover:bg-[#1f5a7a] disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors">{loading ? (<><Loader2 className="w-4 h-4 animate-spin mr-2" />Enregistrement...</>) : (<>Enregistrer ({pointagesBatch.length + nombreDepartsSaisis})</>)}</button></div></div>
            </div>
            <ConfirmDialog
              isOpen={confirmationEnvoiLot}
              onClose={() => setConfirmationEnvoiLot(false)}
              onConfirm={handleEnvoyerLotCompta}
              title="Tout envoyer en comptabilité"
              description={`${etatEnvoiLot.prets.length} pointage(s) du ${selectedDate.toLocaleDateString('fr-FR')} vont partir en comptabilité. Un pointage envoyé ne se modifie plus depuis cette page.`}
              confirmText={`Envoyer ${etatEnvoiLot.prets.length} pointage(s)`}
              cancelText="Annuler"
              type="question"
            >
              {/* `description` porte la phrase principale ; les précisions
                  suivent, une par ligne (ConfirmDialog n'a pas de `message`). */}
              {(etatEnvoiLot.sansDepart > 0 || etatEnvoiLot.retenus.length > 0) && (
                <ul className="space-y-1 text-sm text-gray-600">
                  {etatEnvoiLot.sansDepart > 0 && <li>- {etatEnvoiLot.sansDepart} sans départ badgé (jours passés) : leur durée reste inconnue.</li>}
                  {etatEnvoiLot.retenus.map(({ libelle, nombre }) => <li key={libelle}>- {nombre} {libelle} : ne partiront pas.</li>)}
                </ul>
              )}
            </ConfirmDialog>
            <JustifierAnomalieDialog
              ouvert={Boolean(anomalieAJustifier)}
              onFermer={() => setAnomalieAJustifier(null)}
              employe={anomalieAJustifier?.employe}
              pointage={anomalieAJustifier?.pointage}
              anomalies={anomalieAJustifier ? getAnomalieLabels(anomalieAJustifier.pointage) : []}
              dateLibelle={selectedDate.toLocaleDateString('fr-FR', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' })}
              onEnregistre={handleAnomalieJustifiee}
              seulementCorriger={seulementCorriger}
            />
          </div>


         )}

          </div>
            ) : (


          /* Mode Historique */
            <div className="space-y-6">
              {/* Filtres et recherche */}
              <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
                  <div className="p-2 bg-[#246990] rounded-full mr-4">
                    <History className="text-white" size={20} />
                  </div>
                  <div className="flex-1">
                    <h2 className="font-medium text-[#246990] text-xl">Historique des pointages</h2>
                    <p className="text-sm text-gray-600">Pointages du {formatDateForDisplay(selectedDate)}</p>
                  </div>
                  {paieOuverte && (
                    <button
                      onClick={() => handleSendToAccounting()}
                      className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                    >
                      <Send className="w-4 h-4 mr-2" />
                      Envoyer tous à la comptabilité
                    </button>
                  )}
                </div>

                <div className="flex flex-col sm:flex-row gap-4">
                  <div className="flex-1 relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                    <input
                      type="text"
                      placeholder="Rechercher par enseignant ou classe..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                    />
                  </div>

                  {/* La liste déroulante de la charte (ChampSelect), plus un
                      <select> natif (03/11/2026). Radix refuse une option de
                      valeur vide : « Tous les statuts » passe par « tous »,
                      ramené à '' pour le reste de l'écran. */}
                  <div className="sm:w-[220px]">
                    <ChampSelect
                      valeur={filterStatus || 'tous'}
                      onChange={(valeur) => setFilterStatus(valeur === 'tous' ? '' : valeur)}
                      options={FILTRES_STATUT_HISTORIQUE}
                    />
                  </div>

                  {(searchTerm || filterStatus) && (
                    <button
                      onClick={() => {
                        setSearchTerm('');
                        setFilterStatus('');
                      }}
                      className="px-4 py-2 text-gray-600 hover:text-gray-800 border border-gray-300 rounded-lg transition-colors"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  )}
                </div>
              </div>

            {/* Tableau des pointages */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Enseignant
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Classe
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Horaire prévu
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Pointage début
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Pointage fin
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Statut
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Durée
                  </th>
                  {paieOuverte && (
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Comptabilité
                    </th>
                  )}
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody className="bg-white divide-y divide-gray-200">
                {filteredPointages.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="px-6 py-12 text-center text-gray-500">
                      <div className="p-4 bg-gray-50 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                        <History className="w-8 h-8 text-gray-300" />
                      </div>
                      <h4 className="text-lg font-medium text-gray-700 mb-2">Aucun pointage trouvé</h4>
                      <p className="text-sm">Aucun pointage pour le {formatDateForDisplay(selectedDate)}</p>
                    </td>
                  </tr>
                ) : (
                  filteredPointages.map((pointage) => {
                    const formatHeureLocale = (timestamp) => {
                      if (!timestamp) return '-';
                      return new Date(timestamp).toLocaleTimeString('fr-FR', {
                        hour: '2-digit',
                        minute: '2-digit'
                      });
                    };

                    const getStatutBadge = (statut) => {
                      switch (statut) {
                        case 'a_temps':
                          return { class: 'bg-green-100 text-green-800', icon: CheckCircle, text: 'À l\'heure' };
                        case 'retard':
                          return { class: 'bg-red-100 text-red-800', icon: AlertTriangle, text: 'En retard' };
                        case 'trop_tot':
                          return { class: 'bg-orange-100 text-orange-800', icon: AlertTriangle, text: 'Trop tôt' };
                        case 'absent':
                        default:
                          return { class: 'bg-gray-100 text-gray-800', icon: X, text: 'Absent' };
                      }
                    };

                    const statutBadge = getStatutBadge(pointage.statut_debut);
                    const StatutIcon = statutBadge.icon;

                    return (
                      <tr key={pointage.id} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="w-8 h-8 rounded-full bg-[#246990] text-white flex items-center justify-center mr-3">
                              <User size={16} />
                            </div>
                            <div className="text-sm font-medium text-gray-900">
                              {pointage.enseignant_prenom} {pointage.enseignant_nom}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">{pointage.classe_nom}</div>
                          {pointage.matiere_nom && (
                            <div className="text-xs text-gray-500">{pointage.matiere_nom}</div>
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                          {pointage.heure_debut_prevue?.slice(0, 5)} - {pointage.heure_fin_prevue?.slice(0, 5)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {pointage.heure_debut_locale || '-'}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {pointage.heure_fin_locale || '-'}
                        </td>


                        <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statutBadge.class}`}>
                          <StatutIcon className="w-3 h-3 mr-1" />
                          {statutBadge.text}
                        </span>

                        {pointage.statut_fin && pointage.statut_fin !== 'absent' && (
                          <div className="mt-1">
                            <span className="text-xs text-gray-500">
                              Fin: {pointage.statut_fin}
                            </span>
                          </div>
                        )}

                        {/* ✅ Garder seulement "Enregistré par" */}
                        {pointage.enregistre_par_nom && (
                          <div className="text-xs text-gray-500 mt-2">
                            <span className="font-medium">Enregistré par:</span> {pointage.enregistre_par_nom}
                            {pointage.heure_enregistrement && (
                              <span> à {formatHourValue(pointage.heure_enregistrement)}</span>
                            )}
                          </div>
                        )}
                      </td>


                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {pointage.duree_effective_minutes !== null && pointage.duree_effective_minutes !== undefined ? (
                            `${Math.floor(pointage.duree_effective_minutes / 60)}h${(pointage.duree_effective_minutes % 60).toString().padStart(2, '0')}`
                          ) : '-'}
                        </td>


                        {paieOuverte && (
                        <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          pointage.statut_comptabilite === 'envoye'
                            ? 'bg-blue-100 text-blue-800'
                            : pointage.statut_comptabilite === 'en_paiement'
                              ? 'bg-purple-100 text-purple-800'
                              : pointage.statut_comptabilite === 'paye'
                                ? 'bg-green-100 text-green-800'
                                : 'bg-yellow-100 text-yellow-800'
                        }`}>
                          {pointage.statut_comptabilite === 'envoye' ? (
                            <>
                              <Check className="w-3 h-3 mr-1" />
                              Envoyé
                            </>
                          ) : pointage.statut_comptabilite === 'en_paiement' ? (
                            <>
                              <CreditCard className="w-3 h-3 mr-1" />
                              En paiement
                            </>
                          ) : pointage.statut_comptabilite === 'paye' ? (
                            <>
                              <CheckCircle className="w-3 h-3 mr-1" />
                              Payé
                            </>
                          ) : (
                            <>
                              <Clock className="w-3 h-3 mr-1" />
                              En attente
                            </>
                          )}
                        </span>

                        {/* ✅ AJOUT: Afficher "Envoyé par" uniquement si envoyé */}
                        {pointage.envoye_par_nom && pointage.statut_comptabilite === 'envoye' && (
                          <div className="text-xs text-gray-500 mt-2">
                            <span className="font-medium">Envoyé par:</span> {pointage.envoye_par_nom}
                            {pointage.heure_envoi && (
                              <span> à {formatHourValue(pointage.heure_envoi)}</span>
                            )}
                          </div>
                        )}
                      </td>
                        )}

                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                          <div className="flex items-center justify-end space-x-2">
                            {paieOuverte && !['envoye', 'en_paiement', 'paye'].includes(pointage.statut_comptabilite) && (
                              <button
                                onClick={() => handleSendToAccounting(pointage.id)}
                                className="text-green-600 hover:text-green-800 transition-colors"
                                title="Envoyer à la comptabilité"
                              >
                                <Send className="w-4 h-4" />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

  {/* Observations en expansion */}
  {filteredPointages.length > 0 && (
    <div className="border-t border-gray-200 bg-gray-50">
      <div className="px-6 py-4">
        <h4 className="text-sm font-medium text-gray-700 mb-3 flex items-center">
          <FileText className="w-4 h-4 mr-2" />
          Observations du jour
        </h4>
        <div className="space-y-2">
          {filteredPointages
            .filter(p => p.observations && p.observations.trim())
            .map(pointage => (
              <div key={`obs-${pointage.id}`} className="bg-white rounded-lg p-3 border">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="text-sm font-medium text-gray-900 mb-1">
                      {pointage.enseignant_prenom} {pointage.enseignant_nom} - {pointage.classe_nom}
                    </div>
                    <div className="text-sm text-gray-600">
                      {pointage.observations}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          {filteredPointages.filter(p => p.observations && p.observations.trim()).length === 0 && (
            <div className="text-sm text-gray-500 italic">
              Aucune observation pour cette période
            </div>
          )}
        </div>
      </div>
    </div>
  )}
</div>



              {/* Statistiques avec vraies données */}
              <div className={`grid grid-cols-1 ${paieOuverte ? 'md:grid-cols-4' : 'md:grid-cols-3'} gap-4`}>
                <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                  <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-3">
                    <div className="p-2 bg-[#246990] rounded-full mr-3">
                      <Users className="text-white" size={18} />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-medium text-[#246990] text-lg">Total pointages</h3>
                    </div>
                  </div>
                  <div className="text-2xl font-bold text-gray-900">{pointagesStats.total}</div>
                  <div className="text-sm text-gray-600 mt-1">Enregistrements</div>
                </div>

                <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                  <div className="p-4 bg-green-50 rounded-lg border border-green-200 flex items-center mb-3">
                    <div className="p-2 bg-green-600 rounded-full mr-3">
                      <CheckCircle className="text-white" size={18} />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-medium text-green-700 text-lg">A l'heure</h3>
                    </div>
                  </div>
                  <div className="text-2xl font-bold text-green-600">{pointagesStats.a_temps}</div>
                  <div className="text-sm text-gray-600 mt-1">Ponctuels</div>
                </div>

                <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                  <div className="p-4 bg-red-50 rounded-lg border border-red-200 flex items-center mb-3">
                    <div className="p-2 bg-red-600 rounded-full mr-3">
                      <AlertTriangle className="text-white" size={18} />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-medium text-red-700 text-lg">En retard</h3>
                    </div>
                  </div>
                  <div className="text-2xl font-bold text-red-600">{pointagesStats.retard}</div>
                  <div className="text-sm text-gray-600 mt-1">Retards</div>
                </div>

                {paieOuverte && (
                <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                  <div className="p-4 bg-blue-50 rounded-lg border border-blue-200 flex items-center mb-3">
                    <div className="p-2 bg-blue-600 rounded-full mr-3">
                      <Send className="text-white" size={18} />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-medium text-blue-700 text-lg">Envoyé comptabilité</h3>
                    </div>
                  </div>
                  <div className="text-2xl font-bold text-blue-600">{pointagesStats.envoyes_comptabilite}</div>
                  <div className="text-sm text-gray-600 mt-1">Traités</div>
                </div>
                )}
              </div>
            </div>

                    )}

            {/* Message informatif important - Style VariableElements */}
            <div className="mt-6 p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center">
              <div className="p-2 bg-[#246990] rounded-full mr-4">
                <AlertCircle className="text-white" size={20} />
              </div>
              <div className="flex-1">
                <h5 className="font-medium text-[#246990]">Informations importantes</h5>
                <p className="text-sm text-gray-600">
                  Veuillez bien renseigner les heures car c'est sur la base de ces déclarations de présence que le salaire est calculé, particulièrement pour les enseignants au taux horaire.
                  Les pointages sont automatiquement synchronisés avec le systèmz de paie mensuelle.
                </p>
              </div>
            </div>

            {/* Un refus de lot nomme chaque personne : le message peut être long,
                et la convention le confie alors au LongToast (shouldUseLongToast). */}
            {shouldUseLongToast(toast.message, toast.type) ? (
              <LongToast
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={hideToast}
              />
            ) : (
              <Toast
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={hideToast}
              />
            )}
          </div>

        </div>





      );
    };

    export default CarnetPointageManuel;
